/*21 apps to add (2026-10-07 06:09:54) *//* module data info: ModulosCheck / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio ModulosCheck}*/

var WsModulesCheck = true;

/*{Modulo App Fim ModulosCheck}*/

/* module data info: ExibeHome / all app added at (2026-10-07 06:09:54) *//* module data info: CarrinhosAbandados / none app added at (2026-10-07 06:09:54) *//* module data info: FacebookPixelAPI / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio FacebookPixelAPI}*/

// chamada da funcao do pixel
window.addEventListener("load", () => {
  // Evita execução duplicada se o script for carregado mais de uma vez
  if (window.__metaPixelAPIInitialized) return;
  window.__metaPixelAPIInitialized = true;

  if (document.querySelector("#HdEtapaLoja").value == "HOME") {
    setTimeout(metaPixelAPI, 6500);
  } else {
    setTimeout(metaPixelAPI, 5000);
  }
});

function metaPixelAPI() {
  console.log("metaPixelAPI");
  const pixel = "Fm7ra3w4QAbdMolkqVY+hg==";
  const token = "UXjQMVzIFjx/zNSLxml5lPy62CU0OPgwc6EppOhyELnGNhr3KHSyuZf/LYLRYIGtY53iSmNx5fDlSwa6wj9Qey08Ch8KmhY03V6SJD3JE/aMw7yYpKnyqXKiEoMtJy2XfQJNGy2QKEw4o5UpBh43wYJ6KXAPGK5lt7rSYEmkMpa8o0FJ4bTaOIdovhdUQsnVWtugdDdpdju/XtVezh7BdIE8k46Spov6MKdiNGHhUI/1D+41YKmq+98rFsvItAxNBbE7WxwsNvJcdoyLK9bb5Q==";
  const testEventCode = "";

  // ========== CONTROLE DE DUPLICAÇÃO (apenas para Purchase) ==========

  function getSentEvents() {
    try {
      return JSON.parse(sessionStorage.getItem("metaPixel_sentEvents") || "{}");
    } catch {
      return {};
    }
  }

  function markEventAsSent(eventKey) {
    const sentEvents = getSentEvents();
    sentEvents[eventKey] = Date.now();
    sessionStorage.setItem("metaPixel_sentEvents", JSON.stringify(sentEvents));
  }

  function isEventAlreadySent(eventKey) {
    return !!getSentEvents()[eventKey];
  }

  // Gera um event_id único para deduplicação no Meta
  function generateEventId(eventName, extraData = "") {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 10);
    return `${eventName}_${extraData}_${timestamp}_${random}`;
  }

  // Controle de listeners já adicionados (evita duplicação em SPAs)
  function isListenerAdded(key) {
    if (!window.__metaPixelListeners) window.__metaPixelListeners = {};
    return !!window.__metaPixelListeners[key];
  }

  function markListenerAdded(key) {
    if (!window.__metaPixelListeners) window.__metaPixelListeners = {};
    window.__metaPixelListeners[key] = true;
  }

  // ========== FIM CONTROLE DE DUPLICAÇÃO ==========

  async function postData(eventData) {
    try {
      let url = `https://facebook-meta-api.webstore.net.br/events/add`;

      if (typeof testEventCode == "string" && testEventCode.trim() !== "")
        url += `?testEventCode=${testEventCode}`;

      const storeCode = getStoreCode();

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const bodyToSend = {
        pixelId: pixel,
        token: token,
        storeCode: storeCode,
        events: eventData,
      };

      const config = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(bodyToSend),
      };
      const response = await fetch(url, config);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log("erro na chamada do meta pixel", error);
    }
  }

  function getUnixTimestamp() {
    const date = new Date();
    return Math.floor(date.getTime() / 1000);
  }

  function getStoreCode() {
    const storeCodeEl = document.querySelector("#HD_LV_ID");

    if (!storeCodeEl) return "unknown";

    if (!storeCodeEl.value) return "unknown";

    return storeCodeEl.value;
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  // Constrói o user_data completo com todos os campos disponíveis
  // Os campos de PII serão hasheados (SHA256) no backend
  function buildUserData() {
    const userData = {
      client_user_agent: navigator.userAgent,
    };

    // IP do usuário
    const ipEl = document.querySelector("#HD_USER_INFOIP");
    if (ipEl?.value) {
      userData.client_ip_address = ipEl.value;
    }

    // Cookies do Meta Pixel (melhoram muito o Event Match Quality)
    const fbp = getCookie("_fbp");
    const fbc = getCookie("_fbc");
    if (fbp) userData.fbp = fbp;
    if (fbc) userData.fbc = fbc;

    // Dados do cliente (customerData) - disponível apenas se logado
    try {
      if (typeof customerData !== "undefined" && customerData) {
        // Email
        if (customerData.email) {
          userData.em = customerData.email.toLowerCase().trim();
        }

        // Telefone (prioriza celular)
        const phone = customerData.celular || customerData.fone;
        if (phone) {
          userData.ph = phone.replace(/\D/g, "");
        }

        // Nome - separa em primeiro nome e sobrenome
        if (customerData.nome && customerData.nome !== "Visitante") {
          const nameParts = customerData.nome.trim().toLowerCase().split(/\s+/);
          userData.fn = nameParts[0];
          if (nameParts.length > 1) {
            userData.ln = nameParts[nameParts.length - 1];
          }
        }

        // Gênero (Meta aceita "m" ou "f")
        if (customerData.sexo) {
          userData.ge = customerData.sexo.toLowerCase();
        }

        // Cidade
        if (customerData.cidade) {
          userData.ct = customerData.cidade.toLowerCase().trim();
        }

        // Estado (UF)
        if (customerData.uf) {
          userData.st = customerData.uf.toLowerCase().trim();
        }

        // CEP
        if (customerData.cep) {
          userData.zp = customerData.cep.replace(/\D/g, "");
        }

        // País (sempre Brasil nesse contexto)
        userData.country = "br";

        // External ID (email como identificador externo se disponível)
        if (customerData.email) {
          userData.external_id = customerData.email.toLowerCase().trim();
        }
      }
    } catch (e) {
      // customerData não disponível, segue sem dados do cliente
    }

    // Fallback: tenta pegar email do hidden field se customerData não tiver
    if (!userData.em) {
      const emailEl = document.querySelector("#HD_LVCLI_EMAIL");
      if (emailEl?.value) {
        userData.em = emailEl.value.toLowerCase().trim();
      }
    }

    return userData;
  }

  try {
    const etapa = document.querySelector("#HdEtapaLoja").value;

    const unixTimestamp = getUnixTimestamp();

    const userData = buildUserData();

    const defaultViewContentEvent = {
      event_name: "ViewContent",
      event_time: unixTimestamp,
      action_source: "website",
      original_event_data: {
        event_name: "ViewContent",
        event_time: unixTimestamp,
      },
      user_data: userData,
      event_source_url: document.URL,
    };

    const etapaFunctionMetaAPI = {
      async HOME() {
        if (!wsMain?.globalData?.listHomeProds) {
          setTimeout(etapaFunctionMetaAPI.HOME, 1000);
          return;
        }

        const allProducts = [...wsMain.globalData.listHomeProds.produtos];

        if (wsMain.globalData?.listSuggestionProds) {
          allProducts.push(...wsMain.globalData.listSuggestionProds);
        }

        const prodsSku = allProducts.map((elm) => elm.codigo);

        const contentsToEvent = allProducts.map((elm) => {
          return {
            id: elm.codigo,
            item_price: elm.precos.preco,
          };
        });

        const homeViewContent = { ...defaultViewContentEvent };
        homeViewContent.event_id = generateEventId("ViewContent", "HOME");
        const customData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Home",
          currency: "BRL",
        };

        homeViewContent.custom_data = customData;

        await postData([homeViewContent]);

        // Adiciona listeners apenas uma vez
        if (isListenerAdded("HOME_AddToCart")) return;
        markListenerAdded("HOME_AddToCart");

        const buttonsHome = document.querySelectorAll("a[data-sku]");

        buttonsHome.forEach((btn) => {
          btn.addEventListener("click", async (e) => {
            const addToCartEvent = { ...defaultViewContentEvent };
            addToCartEvent.event_name = "AddToCart";
            addToCartEvent.currency = "BRL";
            addToCartEvent.original_event_data.event_name = "AddToCart";

            const sku = e.target.getAttribute("data-sku");
            addToCartEvent.event_id = generateEventId("AddToCart", sku);

            const prod = allProducts.filter((elm) => elm.codigo == sku);

            const itemAddedToCart = {
              id: sku,
              quantity: 1,
            };

            if (!!prod.length) {
              itemAddedToCart.item_price = prod[0].precos.preco;
            }

            addToCartEvent.contents = [itemAddedToCart];

            await postData([addToCartEvent]);
          });
        });
      },
      async PRODUTO() {
        if (!wsMain?.globalData?.infoProduto) {
          setTimeout(etapaFunctionMetaAPI.PRODUTO, 1000);
          return;
        }

        const productSku = wsMain.globalData.infoProduto.codigo;

        const productViewContent = { ...defaultViewContentEvent };
        productViewContent.event_id = generateEventId(
          "ViewContent",
          productSku,
        );

        const contentsToEvent = [
          {
            id: productSku,
            item_price: wsMain.globalData.infoProduto.precos.preco,
          },
        ];
        const customData = {
          content_ids: productSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Pagina de produto",
          currency: "BRL",
        };

        productViewContent.custom_data = customData;

        await postData([productViewContent]);

        // Adiciona listeners apenas uma vez
        if (isListenerAdded(`PRODUTO_AddToCart_${productSku}`)) return;
        markListenerAdded(`PRODUTO_AddToCart_${productSku}`);

        const buttonBtn = document.querySelectorAll("button[data-sku]");
        if (!buttonBtn.length) return;

        buttonBtn.forEach((btn) => {
          btn.addEventListener("click", async () => {
            const addToCartEvent = { ...defaultViewContentEvent };
            addToCartEvent.event_name = "AddToCart";
            addToCartEvent.original_event_data.event_name = "AddToCart";
            addToCartEvent.currency = "BRL";
            addToCartEvent.event_id = generateEventId("AddToCart", productSku);

            const itemAddedToCart = {
              id: productSku,
              quantity: 1,
            };

            if (!!wsMain.globalData.infoProduto.precos.preco) {
              itemAddedToCart.item_price =
                wsMain.globalData.infoProduto.precos.preco;
            }

            addToCartEvent.contents = [itemAddedToCart];

            await postData([addToCartEvent]);
          });
        });
      },
      async LISTAGEM() {
        if (!wsMain?.globalData?.listCategoryProds?.produtos) {
          setTimeout(etapaFunctionMetaAPI.LISTAGEM, 1000);
          return;
        }

        const allProducts = wsMain.globalData.listCategoryProds.produtos;

        const prodsSku = allProducts.map((elm) => elm.codigo);

        const contentsToEvent = allProducts.map((elm) => {
          const objToReturn = {
            id: elm.codigo,
          };

          if (elm.precos?.preco) objToReturn.item_price = elm.precos.preco;

          return objToReturn;
        });

        const categoryViewContent = { ...defaultViewContentEvent };
        categoryViewContent.event_id = generateEventId(
          "ViewContent",
          "LISTAGEM",
        );
        const customData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Categoria",
          currency: "BRL",
        };

        categoryViewContent.custom_data = customData;

        const eventData = [categoryViewContent];

        const searchTerm = window.location.href.split("/0/")[1];

        if (searchTerm) {
          const searchTermEvent = { ...defaultViewContentEvent };
          searchTermEvent.event_name = "Search";
          searchTermEvent.original_event_data.event_name = "Search";
          searchTermEvent.search_string = searchTerm;
          searchTermEvent.event_id = generateEventId("Search", searchTerm);

          eventData.push(searchTermEvent);
        }

        await postData(eventData);

        // Adiciona listeners apenas uma vez
        if (isListenerAdded("LISTAGEM_AddToCart")) return;
        markListenerAdded("LISTAGEM_AddToCart");

        const buttonBtn = document.querySelectorAll("button[data-sku]");

        if (!buttonBtn.length) return;

        buttonBtn.forEach((btn) => {
          btn.addEventListener("click", async (e) => {
            const addToCartEvent = { ...defaultViewContentEvent };
            addToCartEvent.event_name = "AddToCart";
            addToCartEvent.original_event_data.event_name = "AddToCart";
            addToCartEvent.currency = "BRL";

            const sku = e.target.getAttribute("data-sku");
            addToCartEvent.event_id = generateEventId("AddToCart", sku);

            const prod = allProducts.filter((elm) => elm.codigo == sku);
            const itemAddedToCart = {
              id: sku,
              quantity: 1,
            };

            if (!!prod.length) {
              itemAddedToCart.item_price = prod[0].precos.preco;
            }

            addToCartEvent.contents = [itemAddedToCart];

            await postData([addToCartEvent]);
          });
        });
      },
      async carrinho() {
        if (!wsMain?.globalData?.infoCart?.products) {
          setTimeout(etapaFunctionMetaAPI.carrinho, 1000);
          return;
        }

        const allProducts = wsMain.globalData.infoCart.products;

        const prodsSku = allProducts.map((elm) => elm.sku);

        const contentsToEvent = allProducts.map((elm) => {
          const objToReturn = {
            id: elm.sku,
          };

          if (elm.price) objToReturn.item_price = elm.price;

          return objToReturn;
        });

        const cartViewContent = { ...defaultViewContentEvent };
        cartViewContent.event_id = generateEventId("ViewContent", "carrinho");
        const customData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Carrinho",
          currency: "BRL",
        };

        cartViewContent.custom_data = customData;

        await postData([cartViewContent]);
      },
      async login() {
        const btnLogin = document.querySelector(
          ".LoginCaixaTudo .LoginBLock .CaixaInt #Botao",
        );
        if (!btnLogin) {
          setTimeout(etapaFunctionMetaAPI.login, 1000);
          return;
        }

        const loginViewContent = { ...defaultViewContentEvent };
        loginViewContent.event_id = generateEventId("ViewContent", "login");
        const customData = {
          content_name: "Pagina de login",
        };

        loginViewContent.custom_data = customData;

        await postData([loginViewContent]);

        // Adiciona listener apenas uma vez
        if (isListenerAdded("login_click")) return;
        markListenerAdded("login_click");

        btnLogin.addEventListener("click", async () => {
          const loginEvent = { ...defaultViewContentEvent };
          loginEvent.event_name = "Login";
          loginEvent.original_event_data.event_name = "Login";
          loginEvent.event_id = generateEventId("Login", "click");

          await postData([loginEvent]);
        });
      },
      async CONTATO() {
        const contactViewContent = { ...defaultViewContentEvent };
        contactViewContent.event_id = generateEventId("ViewContent", "CONTATO");

        const customData = {
          content_name: "Pagina de contato",
        };

        contactViewContent.custom_data = customData;

        await postData([contactViewContent]);
      },
      async FORMAS_PAGAMENTO() {
        if (!wsMain?.globalData?.infoCart?.products) {
          setTimeout(etapaFunctionMetaAPI.FORMAS_PAGAMENTO, 1000);
          return;
        }

        const allProducts = wsMain.globalData.infoCart.products;

        const prodsSku = allProducts.map((elm) => elm.sku);
        const cartSkus = allProducts
          .map((p) => p.sku)
          .sort()
          .join(",");

        const contentsToEvent = allProducts.map((elm) => {
          const objToReturn = {
            id: elm.sku,
          };

          if (elm.price) objToReturn.item_price = elm.price;
          if (elm.qtd) objToReturn.quantity = elm.qtd;

          return objToReturn;
        });

        const paymentViewContent = { ...defaultViewContentEvent };
        paymentViewContent.event_id = generateEventId(
          "ViewContent",
          "FORMAS_PAGAMENTO",
        );
        const paymentCustomData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Formas de pagamento",
          currency: "BRL",
        };

        paymentViewContent.custom_data = paymentCustomData;

        // evento de checkout
        const initiateCheckoutEvent = { ...defaultViewContentEvent };
        initiateCheckoutEvent.event_id = generateEventId(
          "InitiateCheckout",
          cartSkus,
        );
        const checkoutCustomData = {
          content_ids: prodsSku,
          contents: contentsToEvent,
          currency: "BRL",
          num_items: wsMain.globalData.infoCart.qtdItems,
          value: wsMain.globalData.infoCart.total,
        };

        initiateCheckoutEvent.event_name = "InitiateCheckout";
        initiateCheckoutEvent.original_event_data.event_name =
          "InitiateCheckout";
        initiateCheckoutEvent.currency = "BRL";

        initiateCheckoutEvent.custom_data = checkoutCustomData;

        await postData([paymentViewContent, initiateCheckoutEvent]);

        // Adiciona listeners apenas uma vez
        if (isListenerAdded("FORMAS_PAGAMENTO_AddPaymentInfo")) return;
        markListenerAdded("FORMAS_PAGAMENTO_AddPaymentInfo");

        const paymentTypeBtns = document.querySelectorAll(
          "label[rel='LinkTipoPagamento']",
        );
        paymentTypeBtns.forEach((paymentBtn) => {
          paymentBtn.addEventListener("click", async (e) => {
            const paymentEvent = { ...defaultViewContentEvent };
            paymentEvent.event_name = "AddPaymentInfo";
            paymentEvent.original_event_data.event_name = "AddPaymentInfo";
            paymentEvent.event_id = generateEventId("AddPaymentInfo", "click");
            paymentEvent.content_ids = prodsSku;
            paymentEvent.contents = contentsToEvent;
            paymentEvent.currency = "BRL";
            paymentEvent.value = wsMain.globalData.infoCart.total;

            await postData([paymentEvent]);
          });
        });
      },
      async FinalPagamento() {
        if (!orderData?.order_id || !orderData?.products) {
          setTimeout(etapaFunctionMetaAPI.FinalPagamento, 1000);
          return;
        }

        // CRÍTICO: Usa identificador único do pedido se disponível, senão usa SKUs + total
        const orderIdentifier =
          orderData.order_id ||
          `${wsMain.globalData.infoCart.products
            .map((p) => p.sku)
            .sort()
            .join(",")}_${wsMain.globalData.infoCart.total}`;

        const purchaseKey = `Purchase_${orderIdentifier}`;

        // Verifica se Purchase já foi enviado para este pedido (proteção local extra)
        if (isEventAlreadySent(purchaseKey)) {
          console.log(
            `Purchase já enviado para pedido ${orderIdentifier}, ignorando duplicação.`,
          );
          return;
        }

        const allProducts = wsMain.globalData.infoCart.products;

        const prodsSku = allProducts.map((elm) => elm.sku);

        const contentsToEvent = allProducts.map((elm) => {
          const objToReturn = {
            id: elm.sku,
          };

          if (elm.price) objToReturn.item_price = elm.price;
          if (elm.qtd) objToReturn.quantity = elm.qtd;

          return objToReturn;
        });

        const finalpaymentViewContent = { ...defaultViewContentEvent };
        finalpaymentViewContent.event_id = generateEventId(
          "ViewContent",
          "FinalPagamento",
        );
        const finalpaymentCustomData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          content_name: "Pagamento final",
          currency: "BRL",
        };

        finalpaymentViewContent.custom_data = finalpaymentCustomData;

        // evento de purchase - usa orderIdentifier como event_id para garantir deduplicação no Meta
        const purchaseEvent = { ...defaultViewContentEvent };
        purchaseEvent.event_id = `purchase_${orderIdentifier}`;
        const purchaseCustomData = {
          content_ids: prodsSku,
          content_type: "product",
          contents: contentsToEvent,
          currency: "BRL",
          num_items: wsMain.globalData.infoCart.qtdItems,
          value: wsMain.globalData.infoCart.total,
        };

        purchaseEvent.event_name = "Purchase";
        purchaseEvent.original_event_data.event_name = "Purchase";

        purchaseEvent.custom_data = purchaseCustomData;

        await postData([finalpaymentViewContent, purchaseEvent]);

        // Marca como enviado APÓS sucesso (proteção local)
        markEventAsSent(purchaseKey);
        console.log(
          `Purchase enviado com sucesso para pedido ${orderIdentifier}`,
        );
      },
    };

    etapaFunctionMetaAPI[etapa] != undefined
      ? etapaFunctionMetaAPI[etapa]()
      : "";

    console.log(
      `Success inserting PIXEL API EVENT script on document, id: ${pixel} (WEBSTORE).`,
    );
  } catch (err) {
    console.log(
      `Error inserting PIXEL API EVENT script on document, id: ${pixel} (WEBSTORE).`,
    );
    console.error(err);
  }
}

/*{Modulo App Fim FacebookPixelAPI}*/

/* module data info: WsCountAccess / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio WsCountAccess}*/

function controle_acesso() {
    
    let LV_ID = document.querySelector('#HD_LV_ID').value;

    function controleAcessoData() {
        const wsgooArr = wsgoo.split(',');
        return wsgooArr.map(elm => ({ event: elm }) )
    }   
    
    async function fetchControleAcesso() {
        try {
            const events = controleAcessoData();
            const url = 'https://analytics-access.wslojas.com.br/events/save';
            const config = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                  },
                body: JSON.stringify({events: events}), 
            }
    
            const response = await fetch( url, config );  
        } catch (error) {
            /*console.log(error)*/
        }
    }

    try {
        const blockedStores = '|29739|29373|10232|1604|122|24465|22496|2855|97|24534|5167|27521|29373|26207|23192|23824|28796|5998|';
        if (blockedStores.indexOf(`|${LV_ID}|`) < 0){
            fetchControleAcesso();
        }
    } catch (error) {
        
    }
}

setTimeout(() => {
    console.log('controle de acesso iniciado');
    controle_acesso();
}, 4000);

/*{Modulo App Fim WsCountAccess}*/

/* module data info: AlertaFreteGratis / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio AlertaFreteGratis}*/

if (!(window.WsApi3Apps && window.WsApi3Apps.freteGratis)) {
  //Linha de ativação do app na WS
  var ws_fretegratis_faltaX = true;

  var htmlfretegratisalert = `<div class="frtalert-quadro">
          <div class="frtalert-texto">Faltam apenas <span>R$ {FaltaX}</span> para voc&ecirc; ganhar frete gr&aacute;tis</div> 
         
          <div class="frtalert-barra-container">
              <div class="frtalert-barra">
                  <div class="frtalert-barra-azul" data-percent="{FaltaPercent}" style="width:0%">
                      <div class="frtalert-caminhao-container">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18.423" height="15.039" viewBox="0 0 18.423 15.039">
                              <path id="Caminho_10089" data-name="Caminho 10089" d="M972.154,6420.539h1.978a1.668,1.668,0,0,1,.408.025.668.668,0,0,1,.245.1,1.826,1.826,0,0,1,.306.271l3.437,3.435a1.774,1.774,0,0,1,.272.305.878.878,0,0,1,.1.245,1.81,1.81,0,0,1,.024.406v2.4a2.074,2.074,0,0,1-.064.744.827.827,0,0,1-.458.457,2.01,2.01,0,0,1-.747.068m-4.231,0h-1.269m0,0v-8.292a4.221,4.221,0,0,0-.184-1.786,1.709,1.709,0,0,0-.74-.736,4.162,4.162,0,0,0-1.784-.187h-4.739a4.162,4.162,0,0,0-1.784.187,1.709,1.709,0,0,0-.74.736,4.221,4.221,0,0,0-.184,1.786v6.6a1.7,1.7,0,0,0,1.692,1.692m8.462,0h-3.385m0,0a2.539,2.539,0,1,1-5.077,0m5.077,0a2.539,2.539,0,1,0-5.077,0m13.962.423a2.115,2.115,0,1,1-2.115-2.115A2.116,2.116,0,0,1,977.654,6429.423Z" transform="translate(-961.25 -6417.25)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                          </svg>
                            
                      </div>
                  </div>              
                  
              </div>
              <p class="frtalert-texto-barra">Frete gr&aacute;tis</p>
          </div>
          
      </div>`;

  window.freeShippingAlert = function freeShippingAlert() {
      const percentElm = document.querySelector('[data-percent]')
      const progressBar = document.querySelector(".frtalert-barra-azul")

      progressBar.style.opacity = 1
          
      if(!percentElm) {
          progressBar.style.width = `6%`
          return
      }

      const percentValue = percentElm.getAttribute('data-percent')

      if(percentValue < 6) {
          progressBar.style.width = `6%`
          return
      }

      if(percentValue > 100) {
          document.querySelector('.frtalert-texto').innerHTML = "<b>A entrega desse pedido ser&aacute; gr&aacute;tis</b>";
          document.querySelector('.frtalert-texto-barra').innerHTML = "<b>Frete gr&aacute;tis</b>";
          progressBar.style.width = `100%`
          return 
      }

      progressBar.style.width = `${percentValue}%`
  }

  //freeShippingAlert()
}

/*{Modulo App Fim AlertaFreteGratis}*/

/* module data info: ModalNovo / all app added at (2026-10-07 06:09:54) *//* module data info: MacHtmlTag / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio MacHtmlTag}*/

(function () {
  try {
    const ua = navigator.userAgent || '';
    const plat = (navigator.platform || '').toLowerCase();
    const uaDataPlat = (navigator.userAgentData && navigator.userAgentData.platform)
      ? navigator.userAgentData.platform.toLowerCase()
      : '';

    let isMac = uaDataPlat === 'macos'
      || /macintosh|mac os x|macintel/.test(ua.toLowerCase())
      || plat.includes('mac');

    const isiPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (isMac && !isiPadOS) {
      document.documentElement.classList.add('os-mac');
    }

    const isSafari = /^((?!chrome|crios|edg|opr|android|fxios).)*safari/i.test(ua);
    if (isMac && !isiPadOS && isSafari) {
      document.documentElement.classList.add('browser-safari');
    }
  } catch (e) {}
})();

/*{Modulo App Fim MacHtmlTag}*/

/* module data info: AdvancedSearch / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio AdvancedSearch}*/

var searchAdvanced = true;

window.setTimeout(() => {
  try {
    wsMain.createModule({
      name: "advanced-search",
      function: "get",
      wsjsOptions: {
        limitToScroll: 8,
        blur: false,
        "suspension-points": true,
        prodsTitleLimits: 3,
        maxProds: 10,
        mobileSuggestion: 5,
        autocomplete: true,
        busca_com_voz: true,
        produtos: true,
        sugestoes: true,
        mais_buscados: [],
      },
      subfunctions: {
        actualInputWord: "",
        actualData: "",
        actualFetchedProducts: {},
        lastFetchedProd: [],
        lastFetchedWord: "",
        actualFetchedSuggestions: [],
        wordToViewAll: "",
        storeID: "",
        secondsToSearch: 1500,
        currentIndex: -1,
        /* Função para criar a div de resultados e adicioná-la ao DOM */
        createResultsDiv() {
          const sugestoesExist =
            wsMain.modules["advanced-search"].wsjsOptions["sugestoes"];
          const produtosExist =
            wsMain.modules["advanced-search"].wsjsOptions["produtos"];

          const resultsDiv = document.createElement("div");
          resultsDiv.id = "advanced-search-results";
          resultsDiv.setAttribute("search-suggestions-type", "default");
          resultsDiv.setAttribute("show-adv-suggestions", sugestoesExist);
          resultsDiv.setAttribute("show-adv-products", produtosExist);

          document.body.appendChild(resultsDiv);
          return resultsDiv;
        },
        /* Função para mostrar a div de resultados com um título */
        showResultsDiv(div, content = "", title = "", attr = "") {
          div.style.display = "flex";
          if (attr) div.setAttribute("search-suggestions-type", attr);
          div.innerHTML = title ? `<h2>${title}</h2>${content}` : content;
        },
        /* Função para esconder a div de resultados */
        hideResultsDiv(div) {
          div.innerHTML = "";
          div.style.display = "none";
        },
        /* Função para obter o histórico de buscas do localStorage */
        getSearchHistory() {
          const history = localStorage.getItem("searchHistory");
          return history ? JSON.parse(history) : [];
        },
        /* Função para salvar um termo de busca no localStorage */
        saveSearchTerm(term) {
          const history =
            wsMain.modules["advanced-search"].subfunctions.getSearchHistory();
          if (term && !history.includes(term)) {
            history.unshift(term);
            if (history.length > 5) {
              history.pop();
            }
            localStorage.setItem("searchHistory", JSON.stringify(history));
          }
        },
        /* Função para configurar o botão "X" para limpar o campo de entrada */
        configureClearButton(input, clearButton) {
          input.addEventListener("input", () => {
            if (input.value.length > 0) {
              clearButton.style.display = "flex";
            } else {
              clearButton.style.display = "none";
            }
          });

          clearButton.addEventListener("click", () => {
            wsMain.modules[
              "advanced-search"
            ].subfunctions.actualFetchedSuggestions = [];
            input.value = "";
            clearButton.style.display = "none";
            input.focus();
          });
        },
        /* Função para exibir o histórico de buscas e os termos mais procurados */
        displaySearchHistoryAndMostSearched(input, div) {
          const history =
            wsMain.modules["advanced-search"].subfunctions.getSearchHistory();
          const mostSearched =
            wsMain.modules["advanced-search"].wsjsOptions.mais_buscados;
          if (history.length === 0 && mostSearched.length === 0) {
            return;
          }

          const suspensionPoints =
            wsMain.modules["advanced-search"].wsjsOptions["suspension-points"];

          /* Cria o HTML para o histórico de busca */
          let historyHtml = "";
          if (history.length > 0) {
            historyHtml = '<p class="titleModulo">Pesquisas recentes</p>';
            historyHtml += history
              .map(
                (item) => `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(item)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                suspension-points="${suspensionPoints}">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <path id="Caminho_9585" data-name="Caminho 9585" d="M1972,5716v6l4,2m6-2a10,10,0,1,1-10-10A10,10,0,0,1,1982,5722Z" transform="translate(-1961 -5711)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                </span>
                ${item.trim()}</a>`
              )
              .join("");
          }

          /* Cria o HTML para os termos mais procurados */
          if (mostSearched.length > 0) {
            let mostSearchedHtml = '<p class="titleModulo">Mais procurados</p>';
            mostSearchedHtml += mostSearched
              .map(
                (item) => `<a
                  href="/busca?s=${wsMain.modules[
                    "advanced-search"
                  ].subfunctions.normalizeQuery(item)}" 
                  class="advanced-search-suggestion">
                  <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                    <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                  </svg>

                  ${item}</a>`
              )
              .join("");
            historyHtml += mostSearchedHtml;
          }

          /* Mostra o conteúdo no elemento de resultados */
          wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
            div,
            historyHtml,
            "",
            "historySearch"
          );
          wsMain.modules[
            "advanced-search"
          ].subfunctions.configureClickNavigation(input, div);
        },
        /* Função para verificar se já passou 24 horas desde a última busca pelos termos mais procurados */
        shouldFetchMostSearched() {
          const lastFetched = localStorage.getItem("lastFetchedMostSearched");
          if (!lastFetched) {
            return true;
          } /* Nunca buscou antes */

          const now = new Date();
          const lastFetchedDate = new Date(lastFetched);
          const diffInHours =
            (now - lastFetchedDate) / (1000 * 60 * 60); /* Diferença em horas */

          return diffInHours >= 24; /* True se passou mais de 24 horas */
        },
        /* Função para salvar os termos mais procurados no localStorage */
        saveMostSearched(mostSearched) {
          localStorage.setItem("mostSearched", JSON.stringify(mostSearched));
          localStorage.setItem(
            "lastFetchedMostSearched",
            new Date().toISOString()
          );
        },
        /* Função para obter os termos mais procurados do localStorage */
        getMostSearched() {
          const mostSearched = localStorage.getItem("mostSearched");
          return mostSearched ? JSON.parse(mostSearched) : [];
        },
        /* Função para mostrar o indicador de loading */
        showLoading(resultsDiv, mainContainer = false) {
          if (mainContainer) {
            const minHeight = resultsDiv.offsetHeight;

            resultsDiv.style.minHeight = `${minHeight}px`;

            const loadingDiv = `<div class="advanced-search-loading-products-container">
                <div class="advanced-search-loading-products"></div>
              </div>`;
            resultsDiv.innerHTML = loadingDiv;

            return;
          }

          const loadingDiv = `<div class="advanced-search-loading-products-container">
                <div class="advanced-search-loading-products"></div>
            </div>`;
          resultsDiv.querySelector(
            ".advanced-search-products-container"
          ).innerHTML = loadingDiv;
        },
        /* Função para remover o indicador de loading */
        hideLoading(resultsDiv) {
          const loadingDiv = resultsDiv.querySelector(
            ".advanced-search-loading-products"
          );
          if (loadingDiv) {
            loadingDiv.remove();
          }
        },
        /* Função para exibir produtos no elemento de resultados */
        displayProducts(products, productsToScroll = 2) {
          if (!products || products.length === 0) {
            return '<p class="no-prods-founded">Nenhum produto encontrado...</p>';
          }

          const productsScroll =
            wsMain.modules["advanced-search"].wsjsOptions.maxProds >
            productsToScroll
              ? "on"
              : "off";

          /* Gera o HTML para os produtos */
          return `
            <div class="advanced-search-products" products-scroll="${productsScroll}">
              ${products
                .map((product, idx) => {
                  if (
                    idx >=
                    wsMain.modules["advanced-search"].wsjsOptions.maxProds
                  ) {
                    return "";
                  }

                  return `<div class="advanced-search-product">
                  <a class="seached-prod-overlay" href="${product.url}"></a>
                  <div class="product-sugestion__image-container">
                    <img src="${product.photo}" alt="${product.name}">
                  </div>
                  <p class="advanced-search-prods-title">${product.name}</p>
                </div>`;
                })
                .join("")}
            </div>`;
        },
        /* Função para adicionar eventos de hover com atraso nas sugestões */
        addHoverListenersToSuggestions(resultsDiv) {
          const suggestions = resultsDiv.querySelectorAll(
            ".advanced-search-suggestion"
          );
          const secondsToSearch =
            wsMain.modules["advanced-search"].subfunctions.secondsToSearch;

          suggestions.forEach((suggestion, idx) => {
            let hoverTimeout;
            let loadingTimeout;

            suggestion.addEventListener("mouseenter", () => {
              const query = suggestion.textContent.trim();
              const input = document.getElementById("input-busca");
              wsMain.modules["advanced-search"].subfunctions.currentIndex = idx;

              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );

              if (
                wsMain.modules["advanced-search"].subfunctions
                  .actualFetchedProducts[query]
              ) {
                const productsContainer = resultsDiv.querySelector(
                  ".advanced-search-products-container"
                );
                if (productsContainer) {
                  productsContainer.innerHTML =
                    wsMain.modules[
                      "advanced-search"
                    ].subfunctions.actualFetchedProducts[query];
                }
                return;
              }

              loadingTimeout = setTimeout(() => {
                wsMain.modules["advanced-search"].subfunctions.showLoading(
                  resultsDiv
                );
              }, 300);

              /* Inicia o timer de 3 segundos ao passar o mouse na sugestão */
              hoverTimeout = setTimeout(() => {
                const input = document.getElementById("input-busca");
                wsMain.modules["advanced-search"].subfunctions.currentIndex =
                  idx;

                wsMain.modules[
                  "advanced-search"
                ].subfunctions.updateSuggestionHighlight(
                  suggestions,
                  wsMain.modules["advanced-search"].subfunctions.currentIndex,
                  input
                );

                wsMain.modules["advanced-search"].subfunctions.fetchProducts(
                  query,
                  resultsDiv
                ); /* Busca os produtos para a sugestão */
              }, secondsToSearch);
            });

            suggestion.addEventListener("mouseleave", () => {
              clearTimeout(hoverTimeout);
              clearTimeout(loadingTimeout);

              if (
                wsMain.modules["advanced-search"].subfunctions.lastFetchedProd
                  .length > 0 &&
                wsMain.modules["advanced-search"].subfunctions
                  .lastFetchedWord &&
                wsMain.modules["advanced-search"].wsjsOptions.produtos
              ) {
                const productsContainer = resultsDiv.querySelector(
                  ".advanced-search-products-container"
                );
                if (productsContainer) {
                  const word =
                    wsMain.modules["advanced-search"].subfunctions
                      .lastFetchedWord;
                  const lastProductHtml =
                    wsMain.modules["advanced-search"].subfunctions
                      .lastFetchedProd[0][word];
                  productsContainer.innerHTML = lastProductHtml;
                }
                return;
              }
            });
          });
        },
        normalizeQuery(query) {
          if (typeof query !== "string") {
            return;
          }

          return query
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9\s-]/g, "")
            .replace(/\s+/g, " ");
        },
        viewAllResultsLink(query) {
          return `<a href="/busca?s=${query}"
          class="view-all-results-link" 
          title="Resultados da busca">Ver todos os resultados</a>`;
        },
        /* Função para autocompletar no input */
        autocompleteInput(input, suggestions, resultsDiv) {
          if (!wsMain.modules["advanced-search"].wsjsOptions["autocomplete"]) {
            return;
          }

          const currentValue = input.value.trim().toLowerCase();

          /* Pega a última palavra digitada */
          const words = currentValue.split(" ");
          const lastWord = words[words.length - 1];

          if (!lastWord) return;

          /* Busca uma palavra correspondente dentro das sugestões */
          for (const suggestion of suggestions) {
            const wordsInSuggestion = suggestion.search
              .toLowerCase()
              .split(" ");

            const match = wordsInSuggestion.find((word) =>
              word.startsWith(lastWord)
            );

            if (match) {
              /* Monta a nova string com a sugestão */
              const autocompleteText = match.slice(lastWord.length);
              words[words.length - 1] = lastWord + autocompleteText;
              input.value = words.join(" ");

              /* Seleciona apenas o texto sugerido */
              input.setSelectionRange(currentValue.length, input.value.length);

              wsMain.modules["advanced-search"].subfunctions.actualInputWord =
                input.value;
              break; // Para no primeiro match encontrado
            }
          }

          const suggestionsDiv = resultsDiv.querySelector(
            ".advanced-search-suggestions-container .advanced-search-suggestions-options"
          );

          suggestionsDiv.setAttribute("autocomplete-inserted", "true");
        },
        /* Função para buscar os termos mais procurados do servidor e armazená-los */
        async fetchAndSaveMostSearched() {
          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=`;

          try {
            const response = await fetch(url);
            if (!response.ok) {
              console.error("Error fetching most searched terms");
              return [];
            }

            const data = await response.json();

            const mostSearched = data.most_searched || [];

            wsMain.modules["advanced-search"].subfunctions.saveMostSearched(
              mostSearched
            );
            return mostSearched;
          } catch (error) {
            console.error("Error fetching most searched terms:", error);
            return [];
          }
        },
        /* Função para atualizar apenas os produtos na div de resultados */
        async fetchProducts(query, resultsDiv) {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.lastFetchedProd.length = 0;
          wsMain.modules["advanced-search"].subfunctions.lastFetchedWord = "";

          if (!wsMain.modules["advanced-search"].wsjsOptions["produtos"]) {
            return;
          }
          const normalizedQuery =
            wsMain.modules["advanced-search"].subfunctions.normalizeQuery(
              query
            );

          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=${encodeURIComponent(
            normalizedQuery
          )}`;

          try {
            const response = await fetch(url);
            if (!response.ok) {
              console.error("Error fetching products");
              return;
            }

            wsMain.modules["advanced-search"].subfunctions.wordToViewAll =
              normalizedQuery;

            const data = await response.json();
            const productsHtml =
              wsMain.modules["advanced-search"].subfunctions.displayProducts(
                data.products
              ) +
              wsMain.modules["advanced-search"].subfunctions.viewAllResultsLink(
                wsMain.modules["advanced-search"].subfunctions.wordToViewAll
              );

            /* Atualiza apenas a seção de produtos */
            const productsContainer = resultsDiv.querySelector(
              ".advanced-search-products-container"
            );
            if (productsContainer) {
              productsContainer.innerHTML = productsHtml;
            }

            if (productsHtml && query) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.push({ [query]: productsHtml });
              wsMain.modules[
                "advanced-search"
              ].subfunctions.actualFetchedProducts[query] = productsHtml;
              wsMain.modules["advanced-search"].subfunctions.lastFetchedWord =
                query;
            }

            /* wsMain.modules['advanced-search'].subfunctions.hideLoading(resultsDiv) */
          } catch (error) {
            wsMain.modules["advanced-search"].subfunctions.hideLoading(
              resultsDiv
            );
            console.error("Error fetching products:", error);
          }
        },
        /* Atualização da função fetchSuggestions para incluir produtos */
        async fetchSuggestions(input, resultsDiv, query, force = false) {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.lastFetchedProd.length = 0;
          wsMain.modules["advanced-search"].subfunctions.lastFetchedWord = "";

          const sugestoesExist =
            wsMain.modules["advanced-search"].wsjsOptions["sugestoes"];
          const produtosExist =
            wsMain.modules["advanced-search"].wsjsOptions["produtos"];

          if (!sugestoesExist && !produtosExist) {
            return;
          }

          const normalizedQuery =
            wsMain.modules["advanced-search"].subfunctions.normalizeQuery(
              query
            );

          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=${encodeURIComponent(
            normalizedQuery
          )}`;

          try {
            let data = "";
            if (force) {
              data = wsMain.modules["advanced-search"].subfunctions.actualData;
            } else {
              const response = await fetch(url);
              if (!response.ok) {
                wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
                  resultsDiv,
                  "<p>Erro ao buscar sugestões...</p>",
                  "",
                  "suggestionSearchError"
                );
                return;
              }

              data = await response.json();
            }

            wsMain.modules["advanced-search"].subfunctions.actualData = data;
            wsMain.modules["advanced-search"].subfunctions.actualInputWord =
              query;

            const { suggestions, products } = data;
            console.log("test ~ fetchSuggestions ~ suggestions:", suggestions);

            const suspensionPoints =
              wsMain.modules["advanced-search"].wsjsOptions[
                "suspension-points"
              ];

            if (suggestions.length < 1 && products.length < 1) {
              wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
                resultsDiv,
                "",
                "",
                "suggestionSearchError"
              );
              return;
            }

            if (suggestions.length < 1) {
              suggestions.push({ search: query });
            }

            const suggestionsHtml = suggestions
              .map((item, idx) => {
                if (
                  wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion
                ) {
                  if (
                    idx <
                    wsMain.modules["advanced-search"].wsjsOptions
                      .mobileSuggestion
                  ) {
                    const position = item.search.indexOf(input.value);

                    if (position == -1) {
                      return `<a 
                      href="/busca?s=${wsMain.modules[
                        "advanced-search"
                      ].subfunctions.normalizeQuery(item.search)}" 
                      title="Sugestão de pesquisa" 
                      class="advanced-search-suggestion" 
                      onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                      suspension-points="${suspensionPoints}">
                      <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                        <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                      </svg>
                      <span>${item.search.trim()}</span>
                      </a>`;
                    }

                    const before = item.search.trim().slice(0, position);

                    const after = item.search
                      .trim()
                      .slice(position + input.value.length);

                    return `<a 
                    href="/busca?s=${wsMain.modules[
                      "advanced-search"
                    ].subfunctions.normalizeQuery(item.search)}" 
                    title="Sugestão de pesquisa" 
                    class="advanced-search-suggestion" 
                    onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                    suspension-points="${suspensionPoints}">
                    <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                      <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                    </svg>
                    <span>${before ? `<strong>${before}</strong>` : ""}<span>${
                      input.value
                    }</span>${after ? `<strong>${after}</strong>` : ""}</span>
                    </a>`;
                  }

                  return "";
                }

                return `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(item.search)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${item.search.trim()}</span>
                </a>`;
              })
              .join("");

            if (suggestions[0].search) {
              wsMain.modules["advanced-search"].subfunctions.wordToViewAll =
                normalizedQuery.replace(/ /g, "-");
            }

            const suggestionsScroll =
              suggestions.length >
                wsMain.modules["advanced-search"].wsjsOptions.limitToScroll &&
              !wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion
                ? "on"
                : "off";

            let productsToScroll = 2;
            if (!sugestoesExist) {
              productsToScroll = 3;
            }

            const productsHtml =
              wsMain.modules["advanced-search"].subfunctions.displayProducts(
                products,
                productsToScroll
              ) +
              wsMain.modules["advanced-search"].subfunctions.viewAllResultsLink(
                wsMain.modules["advanced-search"].subfunctions.wordToViewAll
              );

            wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
              resultsDiv,
              `
              <div class="advanced-search-results-container">
                <div class="advanced-search-suggestions-container" suggestion-scroll="${suggestionsScroll}">
                  <div class="advanced-search-suggestions-options-container"  suggestion-scroll="${suggestionsScroll}">
                    <div class="advanced-search-suggestions-options">${
                      sugestoesExist ? suggestionsHtml : ""
                    }</div>
                  </div>
                </div>  
                <div class="advanced-search-products-container">${
                  produtosExist ? productsHtml : ""
                }</div>
              </div>
            `,
              "",
              "suggestionSearch"
            );

            if (produtosExist && normalizedQuery) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.push({
                [normalizedQuery]: productsHtml,
              });
              wsMain.modules["advanced-search"].subfunctions.lastFetchedWord =
                normalizedQuery;
            }

            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "true"
            );
            wsMain.modules["advanced-search"].subfunctions.autocompleteInput(
              input,
              suggestions,
              resultsDiv
            );
            wsMain.modules[
              "advanced-search"
            ].subfunctions.configureClickNavigation(input, resultsDiv);
            wsMain.modules[
              "advanced-search"
            ].subfunctions.addHoverListenersToSuggestions(resultsDiv);

            wsMain.modules[
              "advanced-search"
            ].subfunctions.actualFetchedSuggestions = suggestions;

            resultsDiv.style.minHeight = "";
          } catch (error) {
            wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
              resultsDiv,
              '<p class="advanced-search-searching-error">Erro ao buscar sugestões...</p>',
              "",
              "suggestionSearchError"
            );
            console.error("Erro:", error);
          }
        },
        /* Função para configurar os eventos do campo de busca */
        configureSearchEvents(input, resultsDiv) {
          const debouncedFetchSuggestions = wsMain.modules[
            "advanced-search"
          ].subfunctions.debounce((query) => {
            wsMain.modules["advanced-search"].subfunctions.fetchSuggestions(
              input,
              resultsDiv,
              query
            );
          }, 2000);

          /* Mostra a div de resultados e exibe o histórico e os mais procurados ao clicar no campo de entrada */
          input.addEventListener("click", async () => {
            if (
              input.value.length > 0 &&
              wsMain.modules["advanced-search"].subfunctions.actualData &&
              wsMain.modules[
                "advanced-search"
              ].subfunctions.actualInputWord.startsWith(input.value)
            ) {
              wsMain.modules["advanced-search"].subfunctions.fetchSuggestions(
                input,
                resultsDiv,
                input.value,
                true
              );
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "true"
              );
              return;
            }

            /* realiza uma chamada para obter as palavras mais buscadas */
            /* if (wsMain.modules['advanced-search'].subfunctions.shouldFetchMostSearched()) {
              await wsMain.modules['advanced-search'].subfunctions.fetchAndSaveMostSearched();
            }*/

            wsMain.modules[
              "advanced-search"
            ].subfunctions.displaySearchHistoryAndMostSearched(
              input,
              resultsDiv
            );
            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "true"
            );
          });

          /* Busca sugestões a partir do terceiro caractere digitado com debounce */
          input.addEventListener("input", (e) => {
            const query = e.target.value.trim();
            const updateBold = wsMain.modules[
              "advanced-search"
            ].subfunctions.updateBoldInSugestions(input, resultsDiv);

            if (updateBold) {
              return;
            }
            if (query.length >= 3) {
              wsMain.modules["advanced-search"].subfunctions.showLoading(
                resultsDiv,
                true
              );

              debouncedFetchSuggestions(query);
            } else if (query.length === 0) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.displaySearchHistoryAndMostSearched(
                input,
                resultsDiv
              );
            }
          });

          /* Salva o termo de busca ao pressionar Enter e exibe o histórico atualizado */
          input.addEventListener("keydown", (event) => {
            if (event.key === "Enter" && input.value.trim()) {
              wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
                input.value.trim()
              );
              /* wsMain.modules['advanced-search'].subfunctions.displaySearchHistoryAndMostSearched(input, resultsDiv); */
            }
          });

          if (window.innerWidth < 900) {
            input.addEventListener("focusin", () => {
              document.body.style.zoom = "1";
            });

            input.addEventListener("focusout", () => {
              document.body.style.zoom = "";
            });
          }

          /* Evento para o botão "X" (limpar campo de busca) */
          const clearButton = document.querySelector(
            ".advanced-search-clear-button"
          );
          if (clearButton) {
            clearButton.addEventListener("click", () => {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.length = 0;
              input.value = "";
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "false"
              );
              wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                resultsDiv
              );
            });
          }

          wsMain.modules[
            "advanced-search"
          ].subfunctions.configureKeyboardNavigation(input, resultsDiv);
        },
        updateBoldInSugestions(input, resultsDiv) {
          try {
            if (!input || !resultsDiv) {
              return false;
            }

            const suggestionsElements = resultsDiv.querySelectorAll(
              ".advanced-search-suggestions-options .advanced-search-suggestion > span"
            );

            if (suggestionsElements.length === 0) {
              return false;
            }

            const actualFetchedSuggestions =
              wsMain.modules["advanced-search"].subfunctions
                .actualFetchedSuggestions;

            const suggestionsList = actualFetchedSuggestions.map((sug) =>
              sug.search.trim()
            );

            const filteredSuggestions = suggestionsList.filter((word) => word);

            if (!filteredSuggestions.length) {
              return false;
            }

            const suggestionsDiv = resultsDiv.querySelector(
              ".advanced-search-suggestions-container .advanced-search-suggestions-options"
            );

            suggestionsDiv.innerHTML = "";

            const suspensionPoints =
              wsMain.modules["advanced-search"].wsjsOptions[
                "suspension-points"
              ];

            filteredSuggestions.forEach((word) => {
              const position = word.indexOf(input.value);

              if (position == -1) {
                return `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(word)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                  <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${word}</span>
                </a>`;
              }

              const before = word.slice(0, position);

              const after = word.slice(position + input.value.length);

              const formattedWord = `
              <a 
              href="/busca?s=${wsMain.modules[
                "advanced-search"
              ].subfunctions.normalizeQuery(word)}" 
              title="Sugestão de pesquisa" 
              class="advanced-search-suggestion" 
              onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
              suspension-points="${suspensionPoints}">
              <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
              </svg>
              <span>${before ? `<strong>${before}</strong>` : ""}<span>${
                input.value
              }</span>${after ? `<strong>${after}</strong>` : ""}</span>
              </a>`;

              suggestionsDiv.innerHTML += formattedWord;
            });

            if (
              suggestionsDiv.getAttribute("autocomplete-inserted") === "true"
            ) {
              return true;
            }

            wsMain.modules["advanced-search"].subfunctions.autocompleteInput(
              input,
              actualFetchedSuggestions,
              resultsDiv
            );
            wsMain.modules[
              "advanced-search"
            ].subfunctions.configureClickNavigation(input, resultsDiv);
            wsMain.modules[
              "advanced-search"
            ].subfunctions.addHoverListenersToSuggestions(resultsDiv);

            return true;
          } catch (error) {
            console.log("test ~ updateBoldInSugestions ~ error:", error);
            return false;
          }
        },
        /* Função de debounce para limitar a frequência de requisições */
        debounce(func, delay) {
          let timerId;
          return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => func.apply(this, args), delay);
          };
        },
        /* Função para gerenciar a navegação com o teclado nas sugestões */
        configureKeyboardNavigation(input, resultsDiv) {
          input.addEventListener("keydown", (event) => {
            const suggestions = resultsDiv.querySelectorAll(
              ".advanced-search-suggestion"
            );
            if (suggestions.length === 0) {
              return;
            }

            if (event.key === "ArrowDown") {
              event.preventDefault();
              wsMain.modules["advanced-search"].subfunctions.currentIndex =
                (wsMain.modules["advanced-search"].subfunctions.currentIndex +
                  1) %
                suggestions.length;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
            } else if (event.key === "ArrowUp") {
              event.preventDefault();
              wsMain.modules["advanced-search"].subfunctions.currentIndex =
                (wsMain.modules["advanced-search"].subfunctions.currentIndex -
                  1 +
                  suggestions.length) %
                suggestions.length;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
            } else if (event.key === "Enter") {
              wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
                input.value.trim()
              );
              if (
                wsMain.modules["advanced-search"].subfunctions.currentIndex >= 0
              ) {
                input.value =
                  suggestions[
                    wsMain.modules["advanced-search"].subfunctions.currentIndex
                  ].textContent;
                wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                  resultsDiv
                );
                const wordToRedirect = wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(input.value);
                window.location.href = `/busca?s=${wordToRedirect}`;
              } else {
                const wordToRedirect = wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(input.value);
                window.location.href = `/busca?s=${wordToRedirect}`;
              }
            }
          });

          document.addEventListener("click", (event) => {
            if (
              document
                .querySelector("#advanced-search-results")
                .contains(event.target) ||
              document.querySelector("#input-busca").contains(event.target)
            ) {
              return;
            }

            wsMain.modules["advanced-search"].subfunctions.currentIndex = -1;
            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "false"
            );
            wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
              resultsDiv
            );
          });

          document.addEventListener("keydown", (event) => {
            if (event.key == "Escape") {
              input.blur();
              wsMain.modules["advanced-search"].subfunctions.currentIndex = -1;
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "false"
              );
              wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                resultsDiv
              );
            }
          });
        },
        configureClickNavigation(input, resultsDiv) {
          const suggestions = resultsDiv.querySelectorAll(
            ".advanced-search-suggestion"
          );
          suggestions.forEach((sug, idx) => {
            sug.addEventListener("click", (e) => {
              wsMain.modules["advanced-search"].subfunctions.currentIndex = idx;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
              input.value = e.target.textContent;
            });
          });
        },
        /* Função para atualizar o destaque na sugestão selecionada */
        updateSuggestionHighlight(suggestions, index, input) {
          suggestions.forEach((item, i) => {
            if (i === index) {
              item.classList.add("active-search");
              input.value = item.textContent.trim();
            } else {
              item.classList.remove("active-search");
            }
          });
        },
        createRecognitionBtn(searchInput) {
          try {
            const searchHeader = document.querySelector(
              "header .search-header"
            );

            if (!searchHeader || !searchInput) {
              return;
            }

            const recogBtn = document.querySelector(".recognition-btn");

            if (!recogBtn) {
              return;
            }

            const recognition = new (window.SpeechRecognition ||
              window.webkitSpeechRecognition)();
            recognition.lang = "pt-BR";
            recognition.continuous = false;
            recognition.interimResults = false;

            recogBtn.addEventListener("click", () => {
              recognition.start();
              recogBtn.classList.add("mic-btn-listening");
            });

            recognition.onresult = (event) => {
              searchInput.value = event.results[0][0].transcript.replace(
                ".",
                ""
              );

              recogBtn.classList.remove("mic-btn-listening");
              searchInput.dispatchEvent(new Event("input", { bubbles: true }));
            };

            recognition.onerror = (event) => {
              recogBtn.classList.remove("mic-btn-listening");
            };
          } catch (error) {}
        },
        /* ativa ou desativa o fundo escuro */
        changeBgState(state) {
          const bgOption = wsMain.modules["advanced-search"].wsjsOptions.blur;

          if (!bgOption) {
            return;
          }

          const suggestionsVrf = document.querySelector(
            "#advanced-search-results .titleModulo"
          );

          if (!suggestionsVrf) {
            return;
          }

          const advancedSearchBg = document.querySelector(
            "#advanced-search-bg"
          );

          advancedSearchBg.setAttribute("advanced-search-bg-active", state);

          const body = document.querySelector("body");

          if (state == "true") body.style.overflow = "hidden";
          else body.style.overflow = "";
        },
        addZindexInput() {
          const inputBusca = document.getElementById("input-busca");

          if (inputBusca) {
            const divPai = inputBusca.parentElement;
            if (divPai) {
              divPai.style.zIndex = "3";
              divPai.style.position = "relative";
            }
          }
        },
        positionCloseBtn() {
          try {
            const input = document.getElementById("input-busca");
            const results = document.getElementById("advanced-search-results");
            const clearButton = document.querySelector(
              "#advanced-search-clear-button"
            );

            if (!input || !results || !clearButton) {
              return;
            }

            clearButton.style.display = "flex";

            const scrollbarWidth =
              wsMain.modules[
                "advanced-search"
              ].subfunctions.getScrollbarWidth();

            const rect = input.getBoundingClientRect();

            const pageWidth = window.innerWidth;

            let distanceFromTop = rect.bottom;

            if (window.innerWidth < 576) {
              results.style.minWidth = input.offsetWidth / 10 + "rem";
            }

            if (document.querySelector("header").style.position == "fixed") {
              results.style.position = "fixed";
            } else {
              results.style.position = "absolute";
            }

            results.style.top = `${distanceFromTop / 10 + 2}rem`;
            results.style.width = input.offsetWidth / 10 + "rem";
            results.style.left = rect.left / 10 + "rem";

            if (window.innerWidth < 1200) {
              results.style.top = `${distanceFromTop + 20}px`;
            }

            if (pageWidth - rect.right + 700 + scrollbarWidth < 1100) {
              results.style.right =
                (pageWidth - rect.right - scrollbarWidth) / 10 + "rem";
              results.style.left = "initial";
            }

            let clearButtonRight = (rect.width - 35) / 10;
            clearButton.style.left = `${clearButtonRight}rem`;

            /* Verifica se o botão de limpar está sobrepondo outro elemento */
            const searchBtn = document.querySelector(
              "header .search-header button"
            );
            const micButton = document.querySelector(
              "header .search-header .recognition-btn"
            );

            const rect1 = clearButton.getBoundingClientRect();
            const rect2 = searchBtn.getBoundingClientRect();

            let rect3 = "";
            if (micButton) {
              rect3 = micButton.getBoundingClientRect();
            }

            clearButton.style.display = "none";

            const horizontalTouchSearchBtn =
              rect1.right >= rect2.left && rect1.left <= rect2.right;
            const verticalTouchSearchBtn =
              rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

            let horizontalTouchMicBtn = "";
            let verticalTouchMicBtn = "";

            if (rect3) {
              horizontalTouchMicBtn =
                rect1.right >= rect3.left && rect1.left <= rect3.right;
              verticalTouchMicBtn =
                rect1.bottom >= rect3.top && rect1.top <= rect3.bottom;
            }

            if (
              (horizontalTouchSearchBtn && verticalTouchSearchBtn) ||
              (horizontalTouchMicBtn && verticalTouchMicBtn)
            ) {
              clearButtonRight = (rect.width - 70) / 10;

              input.style.paddingRight = `7.5rem`;
              clearButton.style.left = `${clearButtonRight}rem`;
            } else {
              input.style.paddingRight = `4.5rem`;
            }
          } catch (error) {}
        },
        positionMic() {
          try {
            const input = document.getElementById("input-busca");
            const micButton = document.querySelector(
              ".search-header .recognition-btn"
            );

            if (!micButton || !input) {
              return;
            }

            const rect = input.getBoundingClientRect();

            /* Verifica se o botão de limpar está sobrepondo outro elemento */
            const searchBtn = document.querySelector(
              "header .search-header button"
            );

            const rect1 = micButton.getBoundingClientRect();
            const rect2 = searchBtn.getBoundingClientRect();

            const horizontalTouch =
              rect1.right >= rect2.left && rect1.left <= rect2.right;

            const verticalTouch =
              rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

            if (horizontalTouch && verticalTouch) {
              micButton.style.left = `${(rect.width - 35) / 10}rem`;
            } else {
              input.style.paddingLeft = `4rem`;
            }
          } catch (error) {}
        },
        getScrollbarWidth() {
          const outer = document.createElement("div");
          outer.style.visibility = "hidden";
          outer.style.overflow = "scroll";
          outer.style.msOverflowStyle = "scrollbar";
          document.body.appendChild(outer);

          const inner = document.createElement("div");
          outer.appendChild(inner);

          const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

          outer.parentNode.removeChild(outer);

          return scrollbarWidth;
        },
        updateOptions(options) {
          try {
            const keys = Object.keys(options);

            if (!keys.length) {
              return;
            }

            keys.forEach((key) => {
              if (key in wsMain.modules["advanced-search"].wsjsOptions) {
                wsMain.modules["advanced-search"].wsjsOptions[key] =
                  options[key];
              }
            });
          } catch (error) {}
        },
        updateOptionsByInfoLojas() {
          try {
            /* const busca = {autocomplete: true, produtos: true, sugestoes: true, busca_com_voz: true, mais_buscados: ['fertilizante', 'estufa']} 
            Object.assign(wsMain?.globalData?.infoLoja, {busca}) */

            const buscaOptions = wsMain?.globalData?.infoLoja?.busca;

            if (!buscaOptions) {
              return;
            }

            buscaOptionsKeys = Object.keys(wsMain?.globalData?.infoLoja?.busca);

            if (!buscaOptionsKeys.length) {
              return;
            }

            buscaOptionsKeys.forEach((key) => {
              if (
                key in wsMain.modules["advanced-search"].wsjsOptions &&
                typeof wsMain?.globalData?.infoLoja?.busca[key] !==
                  "undefined" &&
                wsMain?.globalData?.infoLoja?.busca[key] !== ""
              ) {
                if (key == "mais_buscados") {
                  wsMain.modules["advanced-search"].wsjsOptions[key] =
                    wsMain?.globalData?.infoLoja?.busca[key].filter(
                      (elm) => elm
                    );
                  return;
                }

                wsMain.modules["advanced-search"].wsjsOptions[key] =
                  wsMain?.globalData?.infoLoja?.busca[key];
              }
            });
          } catch (error) {}
        },
        prodsTitleMaxLines() {
          const prodsTitleLimits =
            wsMain.modules["advanced-search"].wsjsOptions.prodsTitleLimits;

          if (prodsTitleLimits < 0) {
            return;
          }

          document.documentElement.style.setProperty(
            "--advanced-search-prods-title-line-clamp",
            prodsTitleLimits
          );
        },
        getStoreId() {
          const storeID = document.querySelector("#HD_LV_ID");

          if (!storeID) {
            return;
          }

          wsMain.modules["advanced-search"].subfunctions.storeID =
            storeID.value;
        },
        updateLocalstorageByQueryParam() {
          const urlParams = new URLSearchParams(window.location.search);
          const search = urlParams.has("s");

          if (search) {
            wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
              urlParams.get("s")
            );
          }
        },
        defaultMobileSettings() {
          if (window.innerWidth > 800) {
            return;
          }

          wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion = 3;
        },
        createDynamicAnchor() {
          const searchHeader = document.querySelector("header .search-header");

          if (!searchHeader) {
            return;
          }

          const vrfClearBtn = document.querySelector(
            "header #advanced-search-clear-button"
          );

          if (!vrfClearBtn) {
            const clearBtn = document.createElement("span");
            clearBtn.id = "advanced-search-clear-button";
            clearBtn.classList.add("advanced-search-clear-button");
            clearBtn.style.display = "none";
            clearBtn.innerHTML = "&#10005;";

            searchHeader.appendChild(clearBtn);
          }

          const vrfRecogBtn = document.querySelector(".recognition-btn");

          if (!vrfRecogBtn) {
            if (wsMain.modules["advanced-search"].wsjsOptions.busca_com_voz) {
              const recognitionBtn = document.createElement("span");
              recognitionBtn.classList.add("recognition-btn");

              recognitionBtn.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"/></svg>
              `;

              searchHeader.appendChild(recognitionBtn);
            }
          }

          const advancedSearchBg = document.querySelector(
            "header #advanced-search-bg"
          );

          if (!advancedSearchBg) {
            const container = document.querySelector(
              "header .header-top .container"
            );

            const advancedSearchBg = document.createElement("div");
            advancedSearchBg.setAttribute("advanced-search-bg-active", "false");
            advancedSearchBg.id = "advanced-search-bg";

            container.appendChild(advancedSearchBg);
          }
        },
        /* Inicializacao */
        initializeSearch() {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.updateOptionsByInfoLojas();
          wsMain.modules["advanced-search"].subfunctions.createDynamicAnchor();

          const searchInput = document.getElementById("input-busca");
          const clearButton = document.getElementById(
            "advanced-search-clear-button"
          );

          wsMain.modules[
            "advanced-search"
          ].subfunctions.updateLocalstorageByQueryParam();

          const resultsDiv =
            wsMain.modules["advanced-search"].subfunctions.createResultsDiv();

          const options = wsMain.tools.getWsData(searchInput, "options");
          wsMain.modules["advanced-search"].subfunctions.updateOptions(options);

          wsMain.modules["advanced-search"].subfunctions.createRecognitionBtn(
            searchInput
          );
          wsMain.modules["advanced-search"].subfunctions.addZindexInput();
          wsMain.modules["advanced-search"].subfunctions.positionMic();
          wsMain.modules["advanced-search"].subfunctions.positionCloseBtn();
          wsMain.modules["advanced-search"].subfunctions.getStoreId();
          wsMain.modules[
            "advanced-search"
          ].subfunctions.defaultMobileSettings();
          wsMain.modules["advanced-search"].subfunctions.prodsTitleMaxLines(
            options
          );
          wsMain.modules["advanced-search"].subfunctions.configureClearButton(
            searchInput,
            clearButton
          );
          wsMain.modules["advanced-search"].subfunctions.configureSearchEvents(
            searchInput,
            resultsDiv
          );
        },
      },
      async get() {
        try {
          if (typeof searchAdvanced_started !== "undefined") {
            return;
          }

          if (!wsMain?.globalData?.infoLoja) {
            setTimeout(() => {
              wsMain.modules["advanced-search"].get();
            }, 1000);
            return;
          }

          searchAdvanced_started = true;

          wsMain.modules["advanced-search"].subfunctions.initializeSearch();

          console.log("busca avancada ");

          return true;
        } catch (error) {
          console.log("test ~ get ~ error:", error);
          return false;
        }
      },
    });
  } catch (e) {
    console.log(`Falha no app advanced search:${e.message}`);
  }

  wsMain.modules["advanced-search"].get();
}, 2000);

/*{Modulo App Fim AdvancedSearch}*/

/* module data info: WsReviews / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio WsReviews}*/

let appWsReviewsTokenView = 'de6fce2621b6a71cc60f01c201d27bf5';
let appWsReviewsStoreId = '71dc407af5ad9f5e2a8513886d398f8b';

if (location.hostname === "localhost") {
    appWsReviewsTokenView = '8193222420197915e0a2cae65410f29a';
    appWsReviewsStoreId = 'a368b0de8b91cfb3f91892fbf1ebd4b2';
}

console.log('reviews teste');

const reviewsCalls = {}

var ws_reviews_options = {};
ws_reviews_options.store_reviews = true;
ws_reviews_options.list_reviews = true;
ws_reviews_options.product_review = true;
reviewsEmpty = true
noEmptyComments = true;
approvalMode = false
// valores disponiveis: rateL (nota mais baixa), rateH (nota mais alta), date (mais recentes) 
// caso tenha um valor invalido, o sera utilizado o filtro de mais recentes
defaultProdPageReviewFilter = 'rateH'


function initializeWsReviews() {
    if (typeof ws_reviews_options_store !== 'undefined') {
        ws_reviews_options = ws_reviews_options_store;
    }

    try{
        if (localStorage["ws_reviews_options_store"]) {
            ws_reviews_options = JSON.parse(localStorage["ws_reviews_options_store"]);
        }
    }catch(e){}

    function reviewsApp() {
        console.log('reviews iniciado');
        const wsStar = wsMain.tools.createElm({
            type: 'span',
            innerHTML: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.44 33.53">
            <defs>
            <linearGradient id="half-star-ws-review"><stop offset="50%" class="alt-main"></stop><stop offset="50%" class="alt-last"></stop></linearGradient></defs><path d="M16.5,.71c.39-.68,1.25-.91,1.92-.53,.22,.12,.4,.31,.53,.53l4.81,8.46c.2,.35,.55,.6,.94,.68l9.61,1.92c.75,.14,1.24,.87,1.1,1.62-.05,.25-.17,.49-.34,.68l-6.64,7.15c-.28,.3-.41,.7-.36,1.1l1.13,9.65c.08,.77-.49,1.46-1.26,1.54-.24,.02-.49-.02-.72-.12l-8.92-4.04c-.37-.17-.8-.17-1.17,0l-8.92,4.05c-.71,.31-1.54,0-1.86-.72-.1-.22-.14-.46-.11-.71l1.13-9.65c.05-.4-.08-.8-.36-1.1L.37,14.08c-.52-.56-.49-1.44,.08-1.96,.19-.18,.43-.29,.68-.34l9.61-1.92c.4-.08,.74-.33,.94-.68L16.5,.71Z"/></svg>
            `
        });

        // diferenca de elementos entre dois arrays
        Array.prototype.diff = function (a) {
            return this.filter((i) => { return a.indexOf(i) < 0; });
        };

        // rendeniza as estrelas e deixa colorido adicionado classes
        function appendStar(reviewId, rate) {
            // contador de estrelas, para adicionar no maximo 5 estrelas
            for (let i = 0; i < 5; i++) {
                starClone = wsStar.cloneNode(true)
                reviewId.append(starClone)

                const star = reviewId.querySelectorAll('span')[i]

                // adiciona classes para estrelas que devem ser vazias, preenchidas ou meias
                if (i == parseInt(rate) && rate % 1 != 0) star.classList.add('half-star');
                else if (i >= rate) star.classList.add('empty-star');
                else if (i < rate) star.classList.add('fill-star');
            };
        }

        // linear gradiente pra deixar a meia estrela amarela
        function creatingLinearGradient() {
            document.querySelector('body').append(
                wsMain.tools.createElm({
                    type: 'defs',
                    id: 'half-star-ws-review',
                    innerHTML: `
                        <stop offset="50%" class="alt-main"></stop>
                        <stop offset="50%" class="alt-last"></stop>
                    `
                })
            )
        }

        // ancora dinamica para ver as avaliacoes no rodape
        function institucionalAnchor() {
            const institutionalContainer = document.querySelector('footer .institutional-footer')
            institutionalContainer.append(
                wsMain.tools.createElm({
                    type: 'li',
                    attrs: {
                        class: "footer-reviews",
                    },
                    innerHTML: '<a href="#nossas-avaliacoes">Avalia&ccedil;&otilde;es</a>',
                })
            )

            institutionalContainer.querySelector('.footer-reviews').addEventListener('click', () => {
                const frame = document.querySelector('.store-reviews')
                frame.style.display = 'block'
                document.querySelector('body').style.overflow = 'hidden'
            })
        }

        // verifica se existem as ancoras para inserir o bloco de reviews
        const dynamicAnchor = {
            bodyAncor() {
                const body = document.querySelector('body')
                body.classList.add('reviews-start')
            },
            productPageAnchor() {
                const mainAnchorVrf = document.querySelector('#clients-review')
                const secondAnchorVrf = document.querySelector('[data-wsjs-product="star-container-product-description"]')

                if (mainAnchorVrf && secondAnchorVrf) return

                if (!mainAnchorVrf) {
                    let container = document.querySelector('.prod-side-container')
                    
                    if (!container) container = document.querySelector('.prod-container .prod-inside-container')
                    
                    container.append(
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                id: 'clients-review',
                                class: 'clients-review'
                            }
                        })
                    )
                }

                if (!secondAnchorVrf) {
                    const referenceElement = document.querySelector(".prod-short-container") ? document.querySelector(".prod-short-container") : document.querySelector('.prod-price-main');
                    const container = referenceElement.parentNode
                    const starsAnchor = wsMain.tools.createElm({
                        type: 'span',
                        attrs: {
                            'data-wsjs-product': 'star-container-product-description'
                        }
                    })

                    if (referenceElement.classList.contains('prod-price-main')) {
                        starsAnchor.classList.add('stars-margin')
                    }

                    container.insertBefore(starsAnchor, referenceElement)
                }
            },
            async homeAnchor(etapa) {
                const mainAnchorVrf = document.querySelector('[data-wsjs-sectype="reviews"]')

                if(etapa !== "HOME" && !mainAnchorVrf) {
                    return false
                }

                if (mainAnchorVrf) return true

                const container = document.querySelector('[data-wsjs-draginner]') || document.querySelector('#DivResponse')

                if ((window.innerWidth <= 800)) {
                    container.appendChild(
                        wsMain.tools.createElm({
                            type: 'section',
                            innerHTML: `
                            <div class="container">
                                <h2>Avalia&ccedil;&otilde;es da loja</h2>
                                <span class="store-review-slider" data-wsjs-slide="slides.perView: 1.5;dots: false; slides.spacing: 10; arrows: false; alignCenter: true;"></span>
                            </div>
                            `,
                            attrs: {
                                'data-wsjs-sectype': 'reviews',
                            }
                        })
                    )
                } else {
                    container.appendChild(
                        wsMain.tools.createElm({
                            type: 'section',
                            innerHTML: `
                            <div class="container">
                                <h2>Avalia&ccedil;&otilde;es da loja</h2>
                                <span class="store-review-slider" data-wsjs-slide="needOffset: true; slides.min: 4; slides.perView: 4;dots: false; slides.spacing: 30; alignCenter: true;"></span>
                            </div>
                            `,
                            attrs: {
                                'data-wsjs-sectype': 'reviews',
                            }
                        })
                    )
                }
                console.log('ancora do slider')
                return true
            },
            storeReview() {
                const anchorVrf = document.querySelector('.store-reviews')
                if (anchorVrf) return

                const container = document.querySelector('body')

                container.appendChild(
                    wsMain.tools.createElm({
                        type: 'div',
                        innerHTML: `
                        <div class="store-reviews__close">
                            <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
                            <path id="Caminho_8519" data-name="Caminho 8519" d="M978,2308l-12,12m0-12,12,12" transform="translate(-964.586 -2306.586)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                            </svg>
                            </span>
                        </div>
                        <iframe src="" frameborder="0"></iframe>
                        `,
                        attrs: {
                            class: 'store-reviews',
                        }
                    })
                )

                console.log('ancora do store review')
            },
            prodAnchor() {
                const prodAnchor = document.querySelectorAll('.prod-showcase-price-container')

                prodAnchor.forEach(elm => {
                    const container = elm.parentNode

                    const vrfy = container.querySelector('.ws-review-star-container')

                    if (vrfy) return

                    const starsAnchor = wsMain.tools.createElm({
                        type: 'span',
                        attrs: {
                            "data-wsjs-prod-template": "ws-review",
                            class: 'ws-review-star-container'
                        }
                    })

                    container.insertBefore(starsAnchor, elm)

                    console.log('ancora no produto ok')
                })
            },
            iframeUrl() {
                console.log('iframeUrl')
                const allHashTags = window.location.hash

                if (allHashTags.includes('#nossas-avaliacoes')) {
                    const frame = document.querySelector('.store-reviews')
                    frame.style.display = 'block'
                    document.querySelector('body').style.overflow = 'hidden'
                }
            }
        }

        // estrelas e reviews da pagina de produto
        const starRatingProductsPage = {
            // data atual
            todayDate() {
                const data = new Date()
                return `${data.toLocaleDateString("pt-BR").split('/').reverse().join('-')} ${data.toString().split(' ')[4]}`
            },

            // botao para proxima pagina
            nextPage(appWsReviewsTokenView, store, response, filter) {
                let page = 2
                const allReviews = document.querySelectorAll('[data-wsjs-review-id]')
                if (allReviews.length == response.total_reviews) return
                if (allReviews.length <= response.total_reviews) {
                    const reviews = document.querySelector('#clients-review-container')
                    reviews.append(
                        wsMain.tools.createElm({
                            type: 'button',
                            innerHTML: 'ver mais coment&aacute;rios',
                            attrs: {
                                class: 'button-third'
                            }
                        }),
                        wsMain.tools.createElm({
                            type: 'div',
                            innerHTML: '<div class="reviews_loader"></div>',
                            attrs: {
                                class: 'loader_container hideLoader'
                            }
                        }),

                    )

                    const btnMoreReviews = document.querySelector('#clients-review-container > .button-third')
                    const loader = document.querySelector('.loader_container')

                    btnMoreReviews.addEventListener('click', async () => {
                        const allReviewsActual = document.querySelectorAll('[data-wsjs-review-id]')
                        // chamada ao endpoint
                        loader.classList.remove('hideLoader')
                        btnMoreReviews.style.display = 'none'
                        const data = await this.getCommentaryData(appWsReviewsTokenView, store, page, filter)
                        btnMoreReviews.style.display = 'block'
                        loader.classList.add('hideLoader')
                        if (allReviewsActual.length == data.total_reviews) {
                            btnMoreReviews.remove()
                        }
                        page++

                        const fatherContainer = btnMoreReviews.parentNode
                        fatherContainer.insertBefore(btnMoreReviews, this.createReviews(data))
                        this.createReportBtn(appWsReviewsTokenView, store)
                    })
                }
            },

            // chamada para receber os dados dos reviews
            async getCommentaryData(appWsReviewsTokenView, store, page = 1, orderBy = ['date', 'rateL', 'rateH'].includes(defaultProdPageReviewFilter) ? defaultProdPageReviewFilter : 'date') {
                const kitObj = wsMain?.globalData?.infoProduto?.kit
                const hasKits = Array.isArray(kitObj) && kitObj.length
                const product = hasKits ? kitObj.map(kit => kit.codigo).join(',') : wsMain.globalData.infoProduto.codigo;
                const queryString = hasKits ? `&products=${product}` : `&product=${product}`

                let lastCookie = ApiWS.Cookie.get(`reviews_product_sku_${product}`, 'D')

                if (lastCookie && page == 1) {
                    if (orderBy == 'date') return lastCookie

                    else if (orderBy) {
                        try {
                            const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}${queryString}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
                            const response = await fetch(url);
                            const data = await response.json();
                            ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', data)
                            return data
                        } catch (error) {
                            console.log(error)
                        }
                    }
                    console.log("localStorage funcionando")
                }

                if (page > 1) {
                    try {
                        const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}${queryString}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
                        const response = await fetch(url);
                        const data = await response.json();

                        data.reviews !== undefined ? lastCookie.reviews.push(...data.reviews) : ''

                        ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', lastCookie)

                        return lastCookie
                    } catch (error) {
                        console.log(error)
                    }
                }

                try {
                    const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}${queryString}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
                    const response = await fetch(url);
                    const data = await response.json();
                    ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', data)
                    reviewsCalls.pagProdFetch = true
                    return data
                } catch (error) {
                    console.log(error)
                }
            },

            // verifica se o usuario esta logado
            async vrfyUser(appWsReviewsTokenView, store, elm, like) {
                const user = document.querySelector('#HD_LVCLI_NOME').value

                // apenas deixa o usuario fazer o fetch se estiver logado
                if (user != 'Visitante') {
                    // like e deslike
                    const dataAtual = this.todayDate()
                    const nome = document.querySelector('#HD_LVCLI_NOME').value
                    const email = document.querySelector('#HD_LVCLI_EMAIL').value
                    document.querySelectorAll(elm).forEach(thumbs => {
                        thumbs.setAttribute('onclick', '')

                        thumbs.addEventListener('click', async (e) => {
                            const reviewId = e.target.parentNode.getAttribute('data-wsjs-likes-review-id')
                            let response
                            try {
                                response = await fetch(`https://reviews-ws-script-app.webstore.net.br/store/reviews/like?store=${store}&review=${reviewId}&tokenView=${appWsReviewsTokenView}`, {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        "name": nome,
                                        "email": email,
                                        "date": dataAtual,
                                        "type": like
                                    })
                                })
                            } catch (error) {
                                console.log(error)
                            }

                            if (!response.ok) {
                                throw new Error(`${response.status}: ${await response.text()}`)
                            }

                            await response.json()
                            thumbs.classList.toggle('liked')
                        })
                    })
                }
            },

            // cria botao de denuncia
            createReportBtn(appWsReviewsTokenView, store) {
                const allReviews = document.querySelectorAll('[data-wsjs-review-id] > .last-half')
                const tresPontos = `<svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.17 65.87">
                <defs>
                <style>
                .cls-1 {
                fill: #393939;
                }
                </style>
                </defs>
                <g id="Camada_1-2" data-name="Camada 1">
                <g id="Grupo_3030" data-name="Grupo 3030">
                <circle id="Elipse_13" data-name="Elipse 13" class="cls-1" cx="6.59" cy="6.59" r="6.59"/>
                <circle id="Elipse_14" data-name="Elipse 14" class="cls-1" cx="6.59" cy="32.94" r="6.59"/>
                <circle id="Elipse_15" data-name="Elipse 15" class="cls-1" cx="6.59" cy="59.28" r="6.59"/>
                </g>
                </g>
                </svg>
                `
                allReviews.forEach(review => {
                    if (!(review.querySelector('.report-options'))) {
                        review.append(
                            wsMain.tools.createElm({
                                type: 'div',
                                attrs: {
                                    class: 'report-options'
                                }
                            }),
                        )
                    }
                })

                const reportOptions = document.querySelectorAll('[data-wsjs-review-id] > .last-half > .report-options')

                reportOptions.forEach(elm => {
                    if (!(elm.querySelector('.report-icon') && elm.querySelector('.report-btn'))) {
                        elm.append(
                            wsMain.tools.createElm({
                                type: 'span',
                                innerHTML: `${tresPontos}`,
                                attrs: {
                                    class: 'report-icon'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'ul',
                                attrs: {
                                    class: 'report-btn'
                                }
                            })
                        )
                    }
                })

                document.querySelectorAll('.report-btn').forEach(div => {
                    div.append(
                        wsMain.tools.createElm({
                            type: 'li',
                            innerHTML: `Denunciar coment&aacute;rio`,
                            attrs: {
                                'report-options': 'report-comentary'
                            }
                        })
                    )
                })

                const liReportOption = document.querySelectorAll('[report-options="report-comentary"]')
                liReportOption.forEach(li => {
                    li.append(
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'report-combobox-btn'
                            }
                        })
                    )

                    li.addEventListener('click', () => {
                        li.childNodes[1].classList.add('report-option-btn-active')
                    })
                })

                document.querySelectorAll('.report-combobox-btn').forEach(div => {
                    div.append(
                        wsMain.tools.createElm({
                            type: 'select',
                            innerHTML: `<option value="0">Selecione o motivo</option>`,
                            attrs: {
                                class: 'report-combobox'
                            }
                        }),
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'send-report'
                            }
                        })
                    )
                })

                const reportOption = document.querySelectorAll('.report-icon')
                reportOption.forEach(icon => {
                    icon.addEventListener('click', () => {
                        icon.nextElementSibling.classList.toggle('active-report-btn')
                        icon.nextElementSibling.childNodes[0].childNodes[1].classList.remove('report-option-btn-active')
                    })

                    document.addEventListener('click', (e) => {
                        if (!icon.contains(e.target) && !icon.nextElementSibling.contains(e.target)) {
                            icon.nextElementSibling.classList.remove('active-report-btn')
                            icon.nextElementSibling.childNodes[0].childNodes[1].classList.remove('report-option-btn-active')

                        }
                    });
                })


                // verifica se o usuario esta logado ou nao
                let user = document.querySelector('#HD_LVCLI_NOME').value
                let email = document.querySelector('#HD_LVCLI_EMAIL').value

                const loginMsg = document.querySelectorAll('.send-report')

                if (user != 'Visitante') {
                    document.querySelectorAll('.send-report').forEach(btn => {
                        btn.classList.add('logged-user')
                    })

                    loginMsg.forEach(msg => {
                        if (!(msg.querySelector('.report-to-send'))) {
                            msg.append(
                                wsMain.tools.createElm({
                                    type: 'span',
                                    innerHTML: 'enviar',
                                    attrs: {
                                        class: 'report-to-send',
                                    }
                                })
                            )
                        }
                    })

                    // opcoes de denuncias do combobox
                    document.querySelectorAll('.report-combobox').forEach(elm => {
                        elm.append(
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Spam',
                                attrs: {
                                    value: 'spam'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Atividades improprias',
                                attrs: {
                                    value: 'atividades-improprias'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Símbolos ou discurso de &oacute;dio',
                                attrs: {
                                    value: 'simbolos-ou-discurso-de-odio'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Violência ou organiza&ccedil;&otilde;es perigosas',
                                attrs: {
                                    value: 'Violencia-ou-organizacoes-perigosas'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Bullying ou ass&eacute;dio',
                                attrs: {
                                    value: 'Bullying-ou-assedio'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Viola&ccedil;&otilde;es de propriedade intelectual',
                                attrs: {
                                    value: 'violacoes-de-propriedade-intelectual'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Golpes ou fraude',
                                attrs: {
                                    value: 'golpes-ou-fraude'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'Informa&ccedil;&atilde;o falsa',
                                attrs: {
                                    value: 'informacoes-falsa'
                                }
                            }),
                            wsMain.tools.createElm({
                                type: 'option',
                                innerHTML: 'outros',
                                attrs: {
                                    value: 'outros'
                                }
                            }),
                        )
                    })

                    // envia os dados para o fetch
                    loginMsg.forEach(btn => {
                        btn.addEventListener('click', async (e) => {
                            const reviewId = e.target.closest('[data-wsjs-review-id]').getAttribute('data-wsjs-review-id')
                            const comboBox = e.target.parentNode.previousSibling
                            const reportReason = comboBox.options[comboBox.selectedIndex].text

                            // chamada ao endpoint
                            let response;
                            try {
                                response = await fetch(`https://reviews-ws-script-app.webstore.net.br/store/reviews/alert?store=${store}&review=${reviewId}&tokenView=${appWsReviewsTokenView}`, {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        "comment": reportReason,
                                        "name": user,
                                        "email": email,
                                        "date": this.todayDate(),
                                        "reviewId": reviewId
                                    })
                                })

                            } catch (error) {
                                console.log(error)
                            }

                            if (!response.ok) {
                                throw new Error(`${response.status}: ${await response.text()}`)
                            }

                            const data = await response.json()
                        })
                    })

                } else {
                    loginMsg.forEach(msg => {
                        msg.remove()
                    })

                    liReportOption.forEach(li => {
                        li.setAttribute('onclick', `window.location.href='/login'`)
                    })

                }
            },

            // calculo para porcentagem da barra de progresso
            totalRatesCalculator(data) {
                let obj = data.rates_total;
                if (!obj) return {};
                const totalOfRates = Object.keys(obj).reduce((r, k) => r + obj[k], 0);

                let objToReturn = {};
                Object.keys(obj).forEach(k => objToReturn[k] = ((obj[k] * 100) / totalOfRates).toFixed(2));

                return objToReturn;
            },

            // estrelas da descricao do produto
            async starsInProdDescription(data) {
                const starContainer = document.querySelector('[data-wsjs-product="star-container-product-description"]')
                starContainer.append(
                    wsMain.tools.createElm({
                        type: 'a',
                        attrs: {
                            title: 'avalições do produto',
                            id: 'link-to-reviews',
                            href: '#clients-average-container'
                        }
                    })
                )

                document.querySelector('#link-to-reviews').append(
                    wsMain.tools.createElm({
                        type: 'span',
                        attrs: {
                            id: 'stars-in-prod-desc'
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'p',
                        attrs: {
                            id: 'stars-in-prod-desc-qnty'
                        }
                    })
                )
                
                starContainer.querySelector('#stars-in-prod-desc-qnty').innerHTML = `(${data.total_reviews})`
                appendStar(starContainer.querySelector('#stars-in-prod-desc'), data.rate_avarege);
            },

            progressBarStructure() {
                // estrutura de containers
                const clientAverageContainer = document.querySelector('#clients-average-container')

                clientAverageContainer.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: "clients-average-container-data"
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: "clients-average-graphic"
                        }
                    }),
                )

                // barra de progresso das reviews
                const clientAverageGraphic = document.querySelector('#clients-average-graphic')
                clientAverageGraphic.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'all-stars-progress-bar'
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'all-progress-bar'
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'all-avaliations-progress-bar'
                        }
                    })
                )

                for (let i = 5; i > 0; i--) {
                    document.querySelector('#all-stars-progress-bar').append(
                        wsMain.tools.createElm({
                            type: 'span',
                            innerHTML: `${i == 1 ? i + ' estrela' : i + ' estrelas'}`
                        })
                    )
                    document.querySelector('#all-progress-bar').append(
                        wsMain.tools.createElm({
                            type: 'div',
                            innerHTML: `<div class="progress-bar" rating-id="r${i}"></div>`,
                            attrs: {
                                class: "progress",
                                "star-number": i
                            }
                        })
                    )
                    document.querySelector('#all-avaliations-progress-bar').append(
                        wsMain.tools.createElm({
                            type: 'span',
                            innerHTML: `r${i}`,
                            attrs: {
                                "ratings": `r${i}`
                            }
                        })
                    )
                }
            },

            clientsAvarageStructure(rateAvarage, totalReviews) {
                const clientAverageDataContainer = document.querySelector('#clients-average-container-data')

                clientAverageDataContainer.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'client-average-data'
                        }
                    }),
                )

                const clientAverageData = document.querySelector('#client-average-data')
                
                totalReviews = totalReviews == 1 ? `${totalReviews} avalia&ccedil;&atilde;o` : `${totalReviews} avalia&ccedil;&otilde;es`                

                clientAverageData.append(
                    wsMain.tools.createElm({
                        type: 'p',
                        attrs: {
                            class: 'nota'
                        },
                        innerHTML: `${rateAvarage}`,
                    }),
                )

                clientAverageData.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'average-all-stars'
                        }
                    })
                )

                clientAverageData.append(
                    wsMain.tools.createElm({
                        type: 'p',
                        innerHTML: `total de ${totalReviews}`,
                    }),
                )
            },

            // media dos users
            async createClientAvarege(response) {
                this.progressBarStructure()

                const percentageOfRates = this.totalRatesCalculator(response)

                const ratingIds = document.querySelectorAll('#all-progress-bar > .progress > [rating-id]')
                for (let i = 1; i <= ratingIds.length; i++) {
                    document.querySelector(`[rating-id=r${i}]`).setAttribute('style', `--percentage: ${percentageOfRates[`r${i}`]}%`)
                }

                document.querySelectorAll('#all-avaliations-progress-bar > span').forEach(rating => {
                    const rate = rating.getAttribute('ratings')
                    rating.innerHTML = response.rates_total[rate]
                })

                this.clientsAvarageStructure(response.rate_avarege, response.total_reviews)
                const clientAverageData = document.querySelector('#client-average-data')
                appendStar(clientAverageData.querySelector('#average-all-stars'), response.rate_avarege)
            },

            // filtros
            async clientsReviewFilter(appWsReviewsTokenView, store) {
                const filterContainer = document.querySelector('#clients-review-filter')

                filterContainer.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        innerHTML: '<span>Ordenar por:</span>',
                        attrs: {
                            class: 'filter-title'
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'select',
                        attrs: {
                            class: 'reviews-filters-container'
                        }
                    })
                )

                document.querySelector('.reviews-filters-container').append(
                    wsMain.tools.createElm({
                        type: 'option',
                        innerHTML: 'Mais recentes',
                        attrs: {
                            class: 'reviews-filters-options',
                            'value': 'date',
                            ...(defaultProdPageReviewFilter === 'date' && { selected: 'true' })
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'option',
                        innerHTML: 'Mais baixa',
                        attrs: {
                            class: 'reviews-filters-options',
                            'value': 'rateL',
                            ...(defaultProdPageReviewFilter === 'rateL' && { selected: 'true' })
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'option',
                        innerHTML: 'Mais alta',
                        attrs: {
                            class: 'reviews-filters-options',
                            'value': 'rateH',
                            ...(defaultProdPageReviewFilter === 'rateH' && { selected: 'true' })
                        }
                    }),
                )

                // faz a nova chamada com o filtro
                document.querySelector('.reviews-filters-container').addEventListener('change', async (e) => {
                    const filter = e.target.value
                    const appReview = document.querySelector('#clients-review-container')
                    
                    appReview.innerHTML = ''
                    appReview.append(
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'loader-container'
                            }
                        })
                        )
                        
                    appReview.querySelector('.loader-container').append(
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'loader'
                            }
                        })
                    )
                        
                    const data = await this.getCommentaryData(appWsReviewsTokenView, store, 1, filter)
                    appReview.querySelector('.loader-container').remove()
                    this.createReviews(data)
                    this.nextPage(appWsReviewsTokenView, store, data, filter)
                    this.createReportBtn(appWsReviewsTokenView, store)
                })
            },

            // cria as reviews
            createReviews(response) {
                const likes = `<svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.43 103.61">
                <defs>
                  <style>
                    .cls-1 {
                      fill: #393939;
                    }
                  </style>
                </defs>
                <g id="Camada_1-2" data-name="Camada 1">
                  <g id="Grupo_3673" data-name="Grupo 3673">
                    <path id="Caminho_4671" data-name="Caminho 4671" class="cls-1" d="M75.15,103.6h-19.49c-4.52,.08-8.92-1.41-12.46-4.21l-15.54-12,4.72-6.1,15.9,12.31c2.16,1.53,4.74,2.32,7.39,2.26h19.49c4.82-.16,9.05-3.28,10.62-7.85l12.41-37.7c.85-1.88,.69-4.05-.41-5.79-1.37-1.71-3.49-2.65-5.69-2.52h-20.51c-2.61,.01-5.1-1.11-6.82-3.08-1.77-2.04-2.54-4.77-2.11-7.44l2.56-16.47c.5-3.03-1.23-5.98-4.1-7.03-2.49-.75-5.19,.06-6.87,2.05l-21.03,31.28-6.36-4.25L47.87,5.8c4.47-6.24,13.15-7.67,19.38-3.2,4.41,3.16,6.57,8.6,5.55,13.92l-2.51,16.16c-.09,.45,.02,.92,.31,1.28,.27,.27,.64,.42,1.02,.41h20.52c4.68-.16,9.15,1.98,11.95,5.74,2.55,3.75,3.07,8.52,1.39,12.74l-12.26,37.34c-2.47,7.92-9.77,13.33-18.06,13.42Z"/>
                    <path id="Caminho_4672" data-name="Caminho 4672" class="cls-1" d="M19.24,97.96h-5.13c-9.49,0-14.11-4.46-14.11-13.59V34.11c0-9.13,4.62-13.59,14.11-13.59h5.13c9.49,0,14.1,4.46,14.1,13.59v50.26c0,9.13-4.6,13.59-14.1,13.59ZM14.11,28.21c-5.59,0-6.41,1.33-6.41,5.9v50.26c0,4.57,.82,5.89,6.41,5.89h5.13c5.59,0,6.41-1.33,6.41-5.89V34.11c0-4.57-.82-5.9-6.41-5.9h-5.13Z"/>
                  </g>
                </g>
                </svg>`

                const reviewContainer = document.querySelector('#clients-review-container')
                response.reviews.forEach((review, i) => {
                    reviewContainer.append(
                        wsMain.tools.createElm({
                            type: 'div',
                            innerHTML: `
                            <div class="first-half">
                            </div>
                            <div class="last-half">
                            <div class='comentary-and-likes'>
                            </div>
                            </div>
                            `,
                            attrs: {
                                'data-wsjs-review-id': review.id,
                            }
                        })
                    )

                    // tratamento da data do review
                    let reviewDate = new Date(review.date).toLocaleString().split(',')
                    reviewDate = reviewDate[0]

                    const reviewDiv = document.querySelector(`[data-wsjs-review-id="${review.id}"]`)

                    if (document.querySelectorAll(`[data-wsjs-review-id="${review.id}"]`).length == 1) {
                        if (!(reviewDiv.querySelector('.stars'))) {
                            const customerArr = review.customer.split(' ')
                            const customer = customerArr.length > 1  ? [customerArr[0], `${customerArr[1][0]}.`] : [customerArr[0]]
                            reviewDiv.querySelector(':scope > .first-half')
                                .append(
                                    wsMain.tools.createElm({
                                        type: 'div',
                                        attrs: {
                                            class: 'stars'
                                        }
                                    }),
                                    wsMain.tools.createElm({
                                        type: 'div',
                                        attrs: {
                                            class: 'customer-infos'
                                        }
                                    })
                                )

                            reviewDiv.querySelector(':scope > .first-half .customer-infos')
                                .append(
                                    wsMain.tools.createElm({
                                        type: 'span',
                                        innerHTML: customer.join(' '),
                                        attrs: {
                                            class: 'customer-infos__name'
                                        }
                                    }),
                                    wsMain.tools.createElm({
                                        type: 'span',
                                        innerHTML: `Avaliada em ${reviewDate}`,
                                        attrs: {
                                            class: 'customer-infos__date'
                                        }
                                    })
                                )

                            reviewDiv.querySelector('.comentary-and-likes')
                                .append(
                                    wsMain.tools.createElm({
                                        type: 'p',
                                        innerHTML: `${review.comment == 'N/A' ? '' : review.comment}`
                                    }),
                                    wsMain.tools.createElm({
                                        type: 'div',
                                        attrs: {
                                            class: 'likes-container'
                                        }
                                    }),
                                )

                            document.querySelector(`[data-wsjs-review-id="${review.id}"] > .last-half > .comentary-and-likes > .likes-container`).append(
                                wsMain.tools.createElm({
                                    type: 'span',
                                    innerHTML: `Esta informa&ccedil;&atilde;o foi &uacute;til?`,
                                    attrs: {
                                        class: 'likes',
                                    }
                                }),
                                wsMain.tools.createElm({
                                    type: 'span',
                                    innerHTML: `${likes} Sim <span>(${review.likes})</span>`,
                                    attrs: {
                                        class: 'likes',
                                        'data-wsjs-likes-review-id': `${review.id}`,
                                        onclick: `window.location.href='/login'`
                                    }
                                }),
                                wsMain.tools.createElm({
                                    type: 'span',
                                    innerHTML: `${likes} N&atilde;o <span>(${review.deslikes})</span>`,
                                    attrs: {
                                        class: 'deslikes',
                                        'data-wsjs-likes-review-id': `${review.id}`,
                                        onclick: `window.location.href='/login'`
                                    }
                                })
                            )
                        }
                        appendStar(reviewDiv.querySelector('.stars'), review.rate)
                    }
                })

                // verifica se há duplicatas e remove
                response.reviews.forEach((review, i) => {
                    let dupReview = document.querySelectorAll(`[data-wsjs-review-id="${review.id}"]`)

                    if (dupReview.length > 1) {
                        for (let i = 1; i < dupReview.length; i++) {
                            dupReview[i].remove()
                        }
                    }
                })
            },

            // chama as outras funcoes desse objeto
            async createContainersAndCallFunctions(appWsReviewsTokenView, store) {
                const orderBy = ['date', 'rateL', 'rateH'].includes(defaultProdPageReviewFilter) ? defaultProdPageReviewFilter : 'date'
                const appReview = document.querySelector('.clients-review')
                const data = await this.getCommentaryData(appWsReviewsTokenView, store, 1, orderBy)

                if (typeof reviewsEmpty !== "undefined" && data.total_reviews == 0 || !data.total_reviews) {
                    document.querySelector('#clients-review').remove()
                    document.querySelector('[data-wsjs-product="star-container-product-description"]').remove()
                    return
                }

                // containers na ancora principal
                appReview.append(
                    wsMain.tools.createElm({
                        type: 'h2',
                        innerHTML: 'Avalia&ccedil;&otilde;es dos clientes'
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-average-container',
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-review-filter',
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-review-container',
                        }
                    })
                )

                if (isNaN(data.rate_avarege)) data.rate_avarege = 0;

                // funcoes
                this.createClientAvarege(data)
                this.starsInProdDescription(data)
                this.createReviews(data)

                this.createReportBtn(appWsReviewsTokenView, store)
                this.vrfyUser(appWsReviewsTokenView, store, '.likes', "like")
                this.vrfyUser(appWsReviewsTokenView, store, '.deslikes', "deslike")
                this.clientsReviewFilter(appWsReviewsTokenView, store)
                this.nextPage(appWsReviewsTokenView, store, data)
            }
        }

        // estrelas da pagina home e relacionados
        const starRatingHome = {
            // funcao para receber dados das estrelas (rating)
            async getData(appWsReviewsTokenView, store) {
                const wsProds = wsMain.globalData.listHomeProds?.produtos;
                const wsGrupos = wsMain.globalData.listGroupProds?.grupos;
                const wsList = wsMain.globalData.listCategoryProds?.produtos;
                const wsRelatedProds = wsMain.globalData.listRelatedProds != null ? wsMain.globalData.listRelatedProds : null;

                // tratativa dos SKU dos produtos
                let prodTotal = []
                if (wsProds) wsProds.forEach(p => {
                    prodTotal.push(p.codigo);
                    if (p.kit && p.kit.length > 0) p.kit.forEach(k => prodTotal.push(k.codigo));
                });
                if (wsGrupos) wsGrupos.forEach(g => g.produtos.forEach(p => {
                    prodTotal.push(p.codigo);
                    if (p.kit && p.kit.length > 0) p.kit.forEach(k => prodTotal.push(k.codigo));
                }));
                if (wsList) wsList.forEach(p => {
                    prodTotal.push(p.codigo);
                    if (p.kit && p.kit.length > 0) p.kit.forEach(k => prodTotal.push(k.codigo));
                });
                if (wsRelatedProds) wsRelatedProds.forEach(p => {
                    prodTotal.push(p.codigo);
                    if (p.kit && p.kit.length > 0) p.kit.forEach(k => prodTotal.push(k.codigo));
                });

                // todos SKU dos produtos sem repeticao para realizar o fetch
                const treatedProds = [...new Set(prodTotal)];

                // cache
                let lastCookie = ApiWS.Cookie.get('reviews_products_home', 'D')
                if (lastCookie) {
                    const arrCookieSku = lastCookie.map(obj => {
                        return obj.sku
                    })

                    if (arrCookieSku.sort().join('') == treatedProds.sort().join('')) {
                        return lastCookie
                    } else {
                        const diference = treatedProds.diff(arrCookieSku)
                        const url = `https://reviews-ws-script-app.webstore.net.br/product/rate?store=${store}&tokenView=${appWsReviewsTokenView}&products=${diference}&approvalMode=${approvalMode}`;
                        let data
                        try {
                            const response = await fetch(url);
                            data = await response.json();
                        } catch (error) {
                            console.log(error)
                        }

                        lastCookie.push(...data)
                        ApiWS.Cookie.set('reviews_products_home', 'D', lastCookie);
                        return lastCookie
                    }
                }

                // dados retornados do fetch (sku + rate)

                try {
                    const url = `https://reviews-ws-script-app.webstore.net.br/product/rate?store=${store}&tokenView=${appWsReviewsTokenView}&products=${treatedProds}&approvalMode=${approvalMode}`;
                    const response = await fetch(url);
                    const data = await response.json();
                    ApiWS.Cookie.set('reviews_products_home', 'D', data);
                    reviewsCalls.homeProdListFetch = true
                    return data
                } catch (err) {
                    console.log(err)
                    return []
                }
            },

            // funcao para criar as estrelas dinamicamente da listagem
            starRatingHome(sku, rate, total) {
                if (typeof reviewsEmpty !== "undefined" && rate == 0) return
                let prodsInPage = document.querySelectorAll(`[ws-prod-sku="${sku}"]`);

                let starClone
                prodsInPage.forEach(prod => {
                    // Verifica se o produto já tem estrelas para evitar duplicação
                    const starContainer = prod.querySelector('.ws-review-star-container');
                    if (!starContainer || starContainer.children.length > 0) return;

                    // contador de estrelas, para adicionar no maximo 5 estrelas
                    for (let i = 0; i < 5; i++) {
                        starClone = wsStar.cloneNode(true)
                        prod.querySelector('.ws-review-star-container').append(starClone)
                        const star = prod.querySelectorAll('.ws-review-star-container > span')[i]

                        // adiciona classes para estrelas que devem ser vazias, preenchidas ou meias
                        if (i == parseInt(rate) && rate % 1 != 0) star.classList.add('half-star');
                        else if (i >= rate) star.classList.add('empty-star');
                        else if (i < rate) star.classList.add('fill-star');
                    };

                    prod.querySelector('.ws-review-star-container').append(
                        wsMain.tools.createElm({
                            type: 'p',
                            innerHTML: `(${total})`,
                            attrs: {
                                class: 'allreviews'
                            }
                        }),
                    )
                })
            },

            // cria um mapa de SKU -> { rate, totalReviews } para busca O(1)
            createRatingMap(response) {
                const ratingMap = {};
                response.forEach(item => {
                    ratingMap[item.sku] = { rate: item.rate, totalReviews: item.totalReviews };
                });
                return ratingMap;
            },

            // coleta todos os produtos das diferentes listas sem duplicatas
            collectAllProducts() {
                const wsProds = wsMain.globalData.listHomeProds?.produtos || [];
                const wsGrupos = wsMain.globalData.listGroupProds?.grupos || [];
                const wsList = wsMain.globalData.listCategoryProds?.produtos || [];
                const wsRelatedProds = wsMain.globalData.listRelatedProds || [];

                let allProducts = [...wsProds, ...wsList, ...wsRelatedProds];
                wsGrupos.forEach(g => {
                    if (g.produtos) allProducts.push(...g.produtos);
                });

                // remove duplicatas baseado no código
                const seen = new Set();
                return allProducts.filter(product => {
                    if (!product || !product.codigo || seen.has(product.codigo)) return false;
                    seen.add(product.codigo);
                    return true;
                });
            },

            // verifica se o produto possui kit válido
            hasValidKit(product) {
                return Array.isArray(product.kit) && product.kit.length > 0;
            },

            // calcula média de rate e soma de totalReviews dos itens do kit
            calculateKitRating(kit, ratingMap) {
                let totalRate = 0;
                let totalReviews = 0;
                let validKitItems = 0;

                kit.forEach(kitItem => {
                    const kitData = ratingMap[kitItem.codigo];
                    if (kitData && kitData.totalReviews > 0) {
                        totalRate += kitData.rate;
                        totalReviews += kitData.totalReviews;
                        validKitItems++;
                    }
                });

                if (validKitItems === 0) return null;

                // calcula a média do rate (arredondado para 1 casa decimal, máximo 5)
                const averageRate = Math.min(5, Math.round((totalRate / validKitItems) * 10) / 10);

                return { rate: averageRate, totalReviews };
            },

            // processa um produto individual (com ou sem kit)
            processProduct(product, ratingMap) {
                if (this.hasValidKit(product)) {
                    const kitRating = this.calculateKitRating(product.kit, ratingMap);
                    if (kitRating) {
                        this.starRatingHome(product.codigo, kitRating.rate, kitRating.totalReviews);
                    }
                } else {
                    const productData = ratingMap[product.codigo];
                    if (productData) {
                        this.starRatingHome(product.codigo, productData.rate, productData.totalReviews);
                    }
                }
            },

            // remove atributo de template das estrelas após processamento
            removeTemplateAttributes() {
                setTimeout(() => {
                    document.querySelectorAll('.ws-review-star-container')
                        .forEach(elm => elm.removeAttribute('data-wsjs-prod-template'));
                }, 1000);
            },

            // pega os dados e cria estrelas
            async getDataAndCreateStars(appWsReviewsTokenView, store) {
                const response = await this.getData(appWsReviewsTokenView, store);
                if (response.length === 0) return;

                const ratingMap = this.createRatingMap(response);
                const allProducts = this.collectAllProducts();

                allProducts.forEach(product => this.processProduct(product, ratingMap));

                this.removeTemplateAttributes();
            },

            // inicializa o observer para carregar avaliações quando novos produtos são adicionados
            initInfinityScrollReviews(appWsReviewsTokenView, store) {
                const list = document.querySelector('[data-wsjs-infinity="holder"]');
                if (!list) return;

                const observer = new MutationObserver((mutations) => {
                    const hasNewProducts = mutations.some(mutation =>
                        mutation.addedNodes.length > 0 &&
                        Array.from(mutation.addedNodes).some(node =>
                            node.nodeType === 1 && node.classList?.contains('prod-showcase-holder')
                        )
                    );

                    if (hasNewProducts) {
                        console.log('INFINITY REVIEWS TRIGGER - Novos produtos detectados');
                        dynamicAnchor.prodAnchor();
                        this.getDataAndCreateStars(appWsReviewsTokenView, store);
                    }
                });

                observer.observe(list, { childList: true });
            }
        }

        const shopReviews = {
            startIframe(appWsReviewsTokenView, store) {
                console.log('startIframe')
                const frame = document.querySelector('.store-reviews > iframe')
                frame.src = `https://reviews-ws-script-app.webstore.net.br/store/reviewstore?tokenView=${appWsReviewsTokenView}&store=${store}`

                this.closeFrame()
            },
            closeFrame() {
                const frame = document.querySelector('.store-reviews')
                const frameBtn = document.querySelector('.store-reviews > .store-reviews__close')

                frameBtn.addEventListener('click', () => {
                    frame.style.display = 'none'
                    document.querySelector('body').style.overflow = 'initial'
                    history.replaceState(null, null, ' ');
                })
            },
            openFrame() {
                document.querySelectorAll('[shop-review]').forEach(review => {
                    review.addEventListener('click', () => {
                        document.querySelector('body').style.overflow = 'hidden'
                        const frame = document.querySelector('.store-reviews')
                        frame.style.display = 'block'
                    })
                })
            }
        }

        // slider de comentarios na pagina home
        const homeReviewSlider = {
            // responsavel por realizar a chamada e obter os dados do endpoint
            async getData(appWsReviewsTokenView, store, limit, orderby) {
                let lastCookie = ApiWS.Cookie.get(`home_slider`, 'D')

                if (lastCookie) return lastCookie

                try {
                    let url = `https://reviews-ws-script-app.webstore.net.br/store/reviews?store=${store}&tokenView=${appWsReviewsTokenView}&fiveStars=true&approvalMode=${approvalMode}`
                    if(limit) url+= `&limit=${limit}`
                    if(orderby) url+= `&orderby=${orderby}`
                    if(noEmptyComments) url+= `&noEmptyComments=${noEmptyComments}`
                    const response = await fetch(url)

                    const data = await response.json()

                    ApiWS.Cookie.set(`home_slider`, 'D', data)
                    reviewsCalls.homeSliderFetch = true
                    return data

                } catch (error) {
                    console.log(error)
                    return { reviews: [] }
                }
            },

            async createReviewSlider(appWsReviewsTokenView, store, etapa) {
                const ancor = await dynamicAnchor.homeAnchor(etapa)
                if(!ancor) return

                const limit = 10
                const orderby = 'date'
                const data = await this.getData(appWsReviewsTokenView, store, limit, orderby)

                if (!data.reviews || data.reviews.length == 0) {
                    const storeReviewsSections = document.querySelector('[data-wsjs-sectype="reviews"]')
                    storeReviewsSections.style.display = 'none'
                    return
                }

                const reviewsTreated = data.reviews
                const sliderContainer = wsMain.tools.createElm('div')

                reviewsTreated.forEach((review, i) => {
                    let index = review.id
                    let date = review.date.split(' ')[0].split('-')
                    if (!Array.isArray(date) || date.length < 2) date = review.date.split('/').reverse()

                    const customerArr = review.customer.toLowerCase().trim().split(' ')
                    let customer = customerArr.length > 1 ? customerArr[0] + ' ' + customerArr[1][0] + '.' : customerArr[0]
                    if (typeof customer == 'undefined') customer = customerArr[0]

                    sliderContainer.append(
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                'shop-review': index,
                            }
                        })
                    )
                    sliderContainer.querySelector(`[shop-review="${index}"]`).append(
                        wsMain.tools.createElm({
                            type: 'a',
                            attrs: {
                                title: 'comentarios da loja',
                                class: 'iframe-redirect',
                                href: '#nossas-avaliacoes'
                            }
                        }),
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'lower-half-infos'
                            }
                        })
                    )

                    if (review.comment !== "N/A" && review.comment.trim() !== '') {
                        sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos`).append(
                            wsMain.tools.createElm({
                                type: 'p',
                                innerHTML: `"${review.comment}"`,
                                attrs: {
                                    class: 'review-commentary'
                                }
                            })
                        )
                    }

                    sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos`).append(
                        wsMain.tools.createElm({
                            type: 'p',
                            innerHTML: customer,
                            attrs: {
                                class: 'customer-name'
                            }
                        }),
                        wsMain.tools.createElm({
                            type: 'p',
                            innerHTML: `Avaliada em ${date[2]}/${date[1]}/${date[0]}`,
                            attrs: {
                                class: 'shop-review__date'
                            }
                        }),
                        wsMain.tools.createElm({
                            type: 'div',
                            attrs: {
                                class: 'review-stars'
                            }
                        }),
                    )

                    appendStar(sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos > .review-stars`), review.rate)
                })


                const options = wsMain.tools.getWsData(document.querySelector('.store-review-slider'), 'slide')

                let [sliderVrf, slider] = wsMain.tools.createSlide(sliderContainer, options)

                wsMain.tools.replaceSpanTag(sliderContainer, document.querySelector('[data-wsjs-sectype="reviews"] .store-review-slider'))

                if (reviewsTreated.length <= 4) {
                    document.querySelector('.store-review-slider').classList.add('no-slider')
                } else if (sliderVrf) slider.update();


                shopReviews.openFrame()
            }
        }

        // reputacao da loja nas paginas institucionais
        const shopPrestige = {
            async getPrestigeData(appWsReviewsTokenView, store) {
                try {
                    const url = `https://reviews-ws-script-app.webstore.net.br/store/reviews?store=${store}&tokenView=${appWsReviewsTokenView}&approvalMode=${approvalMode}`
                    const response = await fetch(url)
                    const data = await response.json()
                    return data
                } catch (error) {
                    console.log(error)
                }
            },

            async createShopPreste(appWsReviewsTokenView, store) {
                const response = await this.getPrestigeData(appWsReviewsTokenView, store)
                const anchor = document.querySelector('.other-pages-row [data-wsjs-prod-template="ws-review-shop"]')

                // estrutura html na ancora
                anchor.append(
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-average-container',
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-review-filter',
                        }
                    }),
                    wsMain.tools.createElm({
                        type: 'div',
                        attrs: {
                            id: 'clients-review-container',
                        }
                    })
                )

                starRatingProductsPage.createClientAvarege(response)
                starRatingProductsPage.createReviews(response)
                starRatingProductsPage.createReportBtn(appWsReviewsTokenView, store)
                starRatingProductsPage.vrfyUser(appWsReviewsTokenView, store, '.likes', "like")
                starRatingProductsPage.vrfyUser(appWsReviewsTokenView, store, '.deslikes', "deslike")
                starRatingProductsPage.clientsReviewFilter(appWsReviewsTokenView, store)
                starRatingProductsPage.nextPage(appWsReviewsTokenView, store, response)
            }
        }

        const appReviewBadges = {
            async getData(storeId) {
                try {
                    const url = `https://reviews-ws-script-app.webstore.net.br/store/stamp?store=${storeId}&approvalMode=${approvalMode}`
                    const response = await fetch(url)
                    const data = await response.json()

                    return data
                } catch (error) {
                    console.log(error)
                }
            },
            async createBadge(storeId) {
                const data = await this.getData(storeId)
                const li = wsMain.tools.createElm('li');

                li.setAttribute('id', data.name.trim().replace(/ /g, ''));

                let holder = wsMain.tools.createElm({
                    type: 'a',
                    attrs: {
                        title: 'insígnias',
                        class: 'badge-holder',
                        target: '_blank',
                        href: data.urlStamp || ''
                    }
                });

                let img = wsMain.tools.createElm({
                    type: 'img',
                    lazyLoad: false,
                    attrs: {
                        src: data.urlStamp,
                        alt: data.name
                    }
                });

                holder.append(img);
                li.append(holder);
                document.querySelector('[data-wsjs-badges]').append(li);
            }
        }

        // pega a etapa da loja, e ativa funcoes para cada etapa
        async function productsRate() {
            // appWsReviewsTokenViews e etapa
            const etapa = document.querySelector('#HdEtapaLoja').value;


            // objeto de funcoes com todas as etapas
            // apenas chama as funcoes de cada etapa
            const etapaFunctions = {
                HOME() {
                    if (ws_reviews_options.list_reviews) {
                        isReady('product-list', () => dynamicAnchor.prodAnchor())
                        isReady('product-list', () => starRatingHome.getDataAndCreateStars(appWsReviewsTokenView, appWsReviewsStoreId))
                        isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
                    }
                    console.log(`home ok ${ws_reviews_options.list_reviews}`)
                },
                LISTAGEM() {
                    if (ws_reviews_options.list_reviews) {
                        isReady('product-list', () => dynamicAnchor.prodAnchor())
                        isReady('product-list', () => starRatingHome.getDataAndCreateStars(appWsReviewsTokenView, appWsReviewsStoreId))
                        isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))

                        if (wsAppsConfig?.infinityList == '2') {
                            isReady('product-list', () => starRatingHome.initInfinityScrollReviews(appWsReviewsTokenView, appWsReviewsStoreId))
                        }
                    }
                    console.log(`listagem ok ${ws_reviews_options.list_reviews}`)
                },
                PRODUTO() {
                    if (ws_reviews_options.product_review) {
                        isReady('pag-produto', () => dynamicAnchor.productPageAnchor())
                        isReady('pag-produto', () => starRatingProductsPage.createContainersAndCallFunctions(appWsReviewsTokenView, appWsReviewsStoreId))
                        isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
                    }
                    console.log(`produto ok ${ws_reviews_options.product_review}`)
                },
                PAGINAS_INST() {
                    isReady('product-list', () => shopPrestige.createShopPreste(appWsReviewsTokenView, appWsReviewsStoreId))
                    isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
                }
            };
            
            // verifica se a etapa e valida, e ativa a funcao de acordo com a etapa
            etapaFunctions[etapa] != undefined ? await etapaFunctions[etapa]() : '';
            // await appReviewBadges.createBadge(store)
        }
        
        try {
            if (ws_reviews_options.store_reviews) {
                dynamicAnchor.bodyAncor()
                dynamicAnchor.storeReview()
                dynamicAnchor.iframeUrl()
                shopReviews.startIframe(appWsReviewsTokenView, appWsReviewsStoreId)
                isReady('info-lojas', () => institucionalAnchor())
                creatingLinearGradient();
            }
            console.log(`kickoff reviews ${JSON.stringify(ws_reviews_options)}`);
            
            productsRate();
        } catch (error) {
            console.log(error);
        }
    }

    try {
        if (typeof dragBase == 'undefined') {
            reviewsApp()
        }
    } catch (error) {
        console.log(error)
    }
}

let wsReviewsInitializationStarted = false

function startWsReviewsWhenReady() {
    if (wsReviewsInitializationStarted) return

    const dependenciesReady =
        document.readyState === 'complete' &&
        document.body &&
        document.querySelector('#HdEtapaLoja') &&
        typeof wsMain !== 'undefined' &&
        wsMain.tools &&
        wsMain.globalData &&
        typeof ApiWS !== 'undefined' &&
        ApiWS.Cookie

    if (!dependenciesReady) {
        setTimeout(startWsReviewsWhenReady, 250)
        return
    }

    wsReviewsInitializationStarted = true
    initializeWsReviews()
}

function scheduleWsReviewsInitialization() {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(startWsReviewsWhenReady, { timeout: 2000 })
        return
    }

    setTimeout(startWsReviewsWhenReady, 0)
}

if (document.readyState === 'complete') {
    scheduleWsReviewsInitialization()
} else {
    window.addEventListener('load', scheduleWsReviewsInitialization, { once: true })
}


/*{Modulo App Fim WsReviews}*/

/* module data info: Compre pelo Whatsapp / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio Compre pelo Whatsapp}*/

window.addEventListener("load", () => {
  if (typeof wsMain == 'object') isReady('pag-produto', modloja_wpp_button_buy);
  else isReady('allModulosOk', 'modloja_wpp_button_buy()');
});

const clearWppButtonUrl = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

function modloja_wpp_button_buy() {

  if (objetos.InfosLojas == undefined || objetos.InfosLojas == null || objetos.ProdutoDadosRetorno == null ||  objetos.ProdutoDadosRetorno == undefined ) {
      window.setTimeout("modloja_wpp_button_buy()", 1000);
      return;
  }

  startWppButtonBuyMod();
}

function startWppButtonBuyMod() {
  let buy_wpp_msg = 'Olá,%0ATenho interesse em adquirir este produto abaixo:%0A%0A' + clearWppButtonUrl(JSON.parse(objetos.ProdutoDadosRetorno).nome) + '%0A' + window.location.href + '%0A%0AObrigado.';
      let btn = document.createElement('a');
      btn.classList.add('wpp-button-custom');
      let foneCorrect = JSON.parse(objetos.InfosLojas).dadoscontato.fone_3.replace(/\D/g, "");
      let LinkUse = "https://web.whatsapp.com/send?phone=55";
      const windowWidth = window.innerWidth;
      btn.href = `${LinkUse}${foneCorrect}&text=${buy_wpp_msg}`;
      if (windowWidth < 900) { 
         LinkUse = "https://wa.me/55"; 
         btn.href = `${LinkUse}${foneCorrect}?text=${buy_wpp_msg}`;
      }
      btn.target = "_blank";
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" pointer-events="all" width="24" height="24" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>';
 
  let legend = document.createElement('span');
      legend.innerHTML = 'Compre pelo WhatsApp';
  
  btn.append(legend);

  let tagSobConsulta = document.querySelector(".preco-sob-consulta");

  if (tagSobConsulta) {
      document.querySelector('[data-mod-whatsapp-button-buy]').remove();
      
      let newTagWpp = document.createElement('span');
      newTagWpp.setAttribute('data-mod-whatsapp-button-buy', '');

      document.querySelector(".preco-sob-consulta").parentNode.insertBefore(newTagWpp, document.querySelector(".preco-sob-consulta").nextSibling);
  }
  
  let spanTagWpp = document.querySelector('[data-mod-whatsapp-button-buy]');

  if (spanTagWpp) {
    try {
      wsMain.tools.replaceSpanTag(btn, spanTagWpp);
    } catch(err) {
      spanTagWpp.parentNode.insertBefore(btn, spanTagWpp);
      document.querySelector('[data-mod-whatsapp-button-buy]').remove();
    }
  } else {
    document.querySelector('[data-mod-whatsapp-button-buy]').remove();
  }
}


/*{Modulo App Fim Compre pelo Whatsapp}*/

/* module data info: FacebookPixel / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio FacebookPixel}*/

window.addEventListener("load", () => {
  if (document.querySelector("#HdEtapaLoja").value == "HOME") { setTimeout(trigger_metaPixel, 6500) }
  else { setTimeout(trigger_metaPixel, 5000) }
});

function trigger_metaPixel() {
  const PIXEL_ID = '928279771309154';

  try {
    const PIXEL_Script = document.createElement('script');
    PIXEL_Script.setAttribute('type', "text/javascript");

    PIXEL_Script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,"script",
    "https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", "${PIXEL_ID}");
    fbq("track", "PageView");`;


    document.querySelector('head').append(PIXEL_Script);
    console.log(`Success inserting head 'script' to PIXEL install, id: ${PIXEL_ID} (Webstore).`);
  } catch (err) {
    console.log(`Error inserting head 'script' to PIXEL install, id: ${PIXEL_ID} (Webstore).`);
    console.error(err);
  }

  try {
    let PIXEL_noScript = document.createElement('noscript');
    PIXEL_noScript.innerHTML = `
  <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1"/>
  `
    document.querySelector('head').append(PIXEL_noScript);
    console.log(`Success inserting head 'noscript' to PIXEL install, id: ${PIXEL_ID} (Webstore).`);
  } catch (err) {
    console.log(`Error inserting head 'noscript' to PIXEL install, id: ${PIXEL_ID} (Webstore).`);
    console.error(err);
  }

  try {
    let etapa = document.querySelector("#HdEtapaLoja").value

    let existEvent = false

    const layers = Array.isArray(window.dataLayer) ? window.dataLayer : [];

    layers.forEach((layer) => {
      let eecObjectProps;

      const eventMap = {
        'view_item_list': 'ViewContent',
        'view_item': 'ViewContent',
        'begin_checkout': 'InitiateCheckout',
        'search': 'Search',
        'purchase': 'Purchase'
      };

      let eventName = eventMap[layer[1]] || false;
      let eventNameSub = '';

      if (!existEvent) {
        existEvent = !!eventName;
      }

      if (!eventName) return;

      let wsProducts = layer[2].items && Array.isArray(layer[2].items) ? layer[2].items : [];

      eecObjectProps = {
        contents: wsProducts.map(prod => { return { id: prod.item_id, quantity: prod.quantity || 1 }; }) || 0,
        currency: 'BRL'
      };

      if (eventName == 'InitiateCheckout' || eventName == 'Purchase') {
        eecObjectProps.value = layer[2].value || 0;
        eecObjectProps.num_items = wsProducts.reduce((acc, cur) => {
          return acc + parseFloat(cur.quantity || 1);
        }, 0);
      }

      if (eventName == 'ViewContent') {
        eventNameSub = 'Product';
        eecObjectProps.content_type = 'Product';
      }

      if (layer[2].item_list_name) eecObjectProps.content_name = layer[2].item_list_name;
      if (etapa == "LISTAGEM") {
        const searchStr = window.location.href.split('/0/')[1]

        if (searchStr) {
          eecObjectProps.content_type = "Search"
          eecObjectProps.content_type = "Search"
          eecObjectProps.search_string = searchStr
          eventNameSub = 'Search';
        }

        if (!searchStr) {
          eecObjectProps.content_type = "Category"
          eventNameSub = 'Category';
        }
      }
      if (etapa == "HOME") {
        eecObjectProps.content_name = "Home";
        eventNameSub = "Home";
      }
      if (layer[2].value) eecObjectProps.value = layer[2].value;

      const FBQ_Script = document.createElement('script');
      if (eventNameSub != '') eventNameSub = "_" + eventNameSub;
      FBQ_Script.innerHTML = `fbq('${eventNameSub ? 'trackCustom' : 'track'}', '${eventName}${eventNameSub}', ${JSON.stringify(eecObjectProps)})`;
      document.body.append(FBQ_Script);
    });

    if (!existEvent) {
      const eventJson = {
        content_name: etapa,
        content_type: etapa,
      }

      const FBQ_Script = document.createElement('script');
      if (etapa) { etapa = "_" + etapa.toLowerCase(); }
      FBQ_Script.innerHTML = `fbq('trackCustom', 'view${etapa}', ${JSON.stringify(eventJson)})`;
      document.body.append(FBQ_Script);
    }

    console.log(`Success inserting PIXEL EVENT script on document, id: ${PIXEL_ID} (WEBSTORE).`);
  } catch (err) {
    console.log(`Error inserting PIXEL EVENT script on document, id: ${PIXEL_ID} (WEBSTORE).`);
    console.error(err);
  }
};


/*{Modulo App Fim FacebookPixel}*/

/* module data info: GoogleAnalytics / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio GoogleAnalytics}*/

(function (w, d) {
    var GA_ID = 'G-2DEN09HH09';
    var FALLBACK_MS = 5000;

    if (!/^(G|GT|AW|UA|DC)-[A-Z0-9-]+$/i.test(GA_ID)) return;
    w.__wsGaLoader = w.__wsGaLoader || {};
    if (w.__wsGaLoader[GA_ID]) return;
    w.__wsGaLoader[GA_ID] = true;

    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', GA_ID);

    var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel', 'mousemove'];
    var OPTS = { passive: true, capture: true };
    var fired = false;
    var timer = null;

    function inject() {
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_ID);
        s.onerror = function () { console.warn('[ws-ga] falha ao carregar ' + GA_ID); };
        d.head.appendChild(s);
    }

    function afterLoad(fn) {
        if (d.readyState === 'complete') fn();
        else w.addEventListener('load', fn, { once: true });
    }

    function whenIdle(fn) {
        if (w.requestIdleCallback) w.requestIdleCallback(fn, { timeout: 2000 });
        else setTimeout(fn, 1);
    }

    function trigger() {
        if (fired) return;
        fired = true;
        clearTimeout(timer);
        EVENTS.forEach(function (e) { w.removeEventListener(e, trigger, OPTS); });
        afterLoad(function () { whenIdle(inject); });
    }

    EVENTS.forEach(function (e) { w.addEventListener(e, trigger, OPTS); });
    afterLoad(function () { timer = setTimeout(trigger, FALLBACK_MS); });
})(window, document);

/*{Modulo App Fim GoogleAnalytics}*/

/* module data info: GoogleAds / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio GoogleAds}*/

(function (w, d) {
    var ADS_ID = '10987057084';
    var FALLBACK_MS = 5000;

    if (!/^(AW|G|GT|DC)-[A-Z0-9-]+$/i.test(ADS_ID)) return;
    w.__wsGtagLoader = w.__wsGtagLoader || {};
    if (w.__wsGtagLoader[ADS_ID]) return;
    w.__wsGtagLoader[ADS_ID] = true;

    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', ADS_ID);

    var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel', 'mousemove'];
    var OPTS = { passive: true, capture: true };
    var fired = false;
    var timer = null;

    function inject() {
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_ID);
        s.onerror = function () { console.warn('[ws-ads] falha ao carregar ' + ADS_ID); };
        d.head.appendChild(s);
    }

    function afterLoad(fn) {
        if (d.readyState === 'complete') fn();
        else w.addEventListener('load', fn, { once: true });
    }

    function whenIdle(fn) {
        if (w.requestIdleCallback) w.requestIdleCallback(fn, { timeout: 2000 });
        else setTimeout(fn, 1);
    }

    function trigger() {
        if (fired) return;
        fired = true;
        clearTimeout(timer);
        EVENTS.forEach(function (e) { w.removeEventListener(e, trigger, OPTS); });
        afterLoad(function () { whenIdle(inject); });
    }

    EVENTS.forEach(function (e) { w.addEventListener(e, trigger, OPTS); });
    afterLoad(function () { timer = setTimeout(trigger, FALLBACK_MS); });
})(window, document);

/*{Modulo App Fim GoogleAds}*/

/* module data info: Favoritos / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio Favoritos}*/

var WsFavoritos = true;

setTimeout(() => {
        try {

            isReady("allModulosOk", "FuncaoVerifFavoritos()");

	    isReady("allModulosOk", FuncaoVerifFavoritos());

            window.setTimeout("funcGetFavoritos()", 500);

        } catch (e) { }
    }
,1000);


function funcAddFavoriteWs(prod) {

    try {

        /*localStorage["prodsWsFav"] = null;*/

        StopFavoriteVerif = true;

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));

        if (!WsFavoritesProds) {
            WsFavoritesProds = [];
        }

        var exist = false;

        for (a = 0; a < WsFavoritesProds.length; a++) {
            if (WsFavoritesProds[a].id == prod) {
                exist = true;
            }
        }

        if (!exist) {

            var element = {};
            element.id = prod;
            WsFavoritesProds.push(element);

        } else {

            funcRemoveFavoriteWs(prod);
            return;

        }

        $("[data='prod-favorite-link-" + prod + "']").addClass("active");
        localStorage.setItem('prodsWsFav', JSON.stringify(WsFavoritesProds));

        window.setTimeout("funcSaveFavoriteWs()", 1000);

    } catch (e) {
        console.log(e.message);
    }

}

function funcRemoveFavoriteWs(prod) {

    try {

        StopFavoriteVerif = true;

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        var WsFavoritesProdsNew = [];

        if (!WsFavoritesProds) {
            return;
        }

        /*console.log("Removendo favorito");*/
        for (a = 0; a < WsFavoritesProds.length; a++) {
            if ((WsFavoritesProds[a].id != prod)) {

                /*console.log("Mantido " + WsFavoritesProds[a].id);*/
                var element = {};
                element.id = WsFavoritesProds[a].id;
                WsFavoritesProdsNew.push(element);

            } else {
                /*console.log("Não Mantido " + WsFavoritesProds[a].id);*/
            }
        }
        
        $("[data='prod-favorite-link-" + prod + "']").removeClass("active");
        localStorage.setItem('prodsWsFav', JSON.stringify(WsFavoritesProdsNew));

        window.setTimeout("funcSaveFavoriteWs()", 1000);

    } catch (e) {
        console.log(e.message);
    }

}

function FuncaoVerifFavoritos() {
    window.setTimeout("FuncaoVerifFavoritosStart()", 2000);
}

var limitFavoritVerif = 0;
var StopFavoriteVerif = false;
function FuncaoVerifFavoritosStart() {

    var CliLogou = localStorage.getItem('favoritesCliId');
    var CliId = $("#HD_LVCLI_ID").val();

    limitFavoritVerif++;
    if (limitFavoritVerif > 5) { return; }

    if ($("#HdSubEtapa").val() == "FAVORITOS" && limitFavoritVerif == 1) {
        funcListaFavoritos();
    }

    try {

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        
        if (!WsFavoritesProds) {
            return;
        }

        for (a = 0; a < WsFavoritesProds.length; a++) {
            try {
                if (!StopFavoriteVerif) {
                    $("[data='prod-favorite-link-" + WsFavoritesProds[a].id + "']").addClass("active");
                }

            } catch (e) { }
        }

        var needSave = localStorage.getItem('prodsWsFav_saved');
        
        var CliLogou = localStorage.getItem('favoritesCliId');
        var CliId = $("#HD_LVCLI_ID").val();

        if (CliLogou != CliId) {
            if (CliId != "0" && CliId != "") {
                needSave = "0";
                localStorage.setItem('favoritesCliId', CliId);
            }
        }

        if (needSave == "0") {
            funcSaveFavoriteWs();
        }

    } catch (e) {
        console.log(e.message);
    }

    window.setTimeout("FuncaoVerifFavoritosStart()", 2000);

}

var varCanSaveFavorite = true;
function funcSaveFavoriteWs() {
    try {

        var JSON = localStorage.getItem('prodsWsFav');
        var CliId = $("#HD_LVCLI_ID").val();

        var saved = "0";

        if (CliId && JSON != "") {

            if (CliId != "" && CliId != "0") {

                if (varCanSaveFavorite) {

                    varCanSaveFavorite = false;

                    let urlAPI = ApiWS.UrlApi ? ApiWS.UrlApi : UrlApi;
                    let VersaoApi = 'api-loja-v2';

                    var Token = $("#HdTokenLojaTemp").val();
                    var URLget = urlAPI + "/" + VersaoApi + "/produtos/favoritos-save";
                    var Parametros = "LOJA=" + ApiWS.LV + "&LvToken=" + Token + "&CliId=" + CliId + "&JSON=" + JSON + "&cacheclear=" + Math.floor((Math.random() * 1000) + 1);

                    $.ajax({
                        type: "GET",
                        url: URLget,
                        data: Parametros,
                        beforeSend: function () { },
                        error: function (e) { console.log("falha ao salvar favoritos " + e.message); varCanSaveFavorite = true; },
                        success: function (retorno) {

                            saved = "1";

                            varCanSaveFavorite = true;
                            console.log("Favoritos saved :" + retorno);
                            if (retorno == "sucesso") {

                            }

                            localStorage.setItem('prodsWsFav_saved', saved);

                        }
                    });

                }

            }

            localStorage.setItem('prodsWsFav_saved', saved);

        }

        
        
    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

function funcListaFavoritos() {
    try {

        console.log("Lista Favoritos");

        var CliId = $("#HD_LVCLI_ID").val();
        var LvId = $("#HD_LV_ID").val();

        if (!CliId) { window.location.href = "/login/" + LvId + "/login"; return; }
        if (CliId == "" || CliId == "0") { window.location.href = "/login/" + LvId + "/login"; return; }

        var Migalha = '<li><a href="/home.aspx?LV_ID=' + LvId + '">P&aacute;gina inicial</a></li><li class="separador">/</li><li><a href="/produtos/favoritos" class="active">Favoritos</a></li>';
        $("#lista-migalha").append(Migalha).show();
        $(".paginacao-ordem").remove();


    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

function funcGetFavoritos() {
    try {

        console.log("Lendo Favoritos do cliente");

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        var CliId = $("#HD_LVCLI_ID").val();

        if (CliId && !WsFavoritesProds) {

            if (CliId != "" && CliId != "0") {

                let urlAPI = ApiWS.UrlApi ? ApiWS.UrlApi : UrlApi;
                let VersaoApi = 'api-loja-v2';

                var Token = $("#HdTokenLojaTemp").val();
                var URLget = urlAPI + "/" + VersaoApi + "/produtos/favoritos-list";
                var Parametros = "LOJA=" + ApiWS.LV + "&LvToken=" + Token + "&CliId=" + CliId + "&cacheclear=" + Math.floor((Math.random() * 1000) + 1);

                $.ajax({
                    type: "GET",
                    url: URLget,
                    data: Parametros,
                    beforeSend: function () { },
                    error: function (e) { console.log("falha ao ler favoritos " + e.message); varCanSaveFavorite = true; },
                    success: function (retorno) {
                        console.log("Favoritos Get:" + retorno);
                        if (retorno.indexOf("JSON:") >= 0) {

                            localStorage.setItem('prodsWsFav', retorno.replace("JSON:", ""));

                        }

                    }
                });

            }

        }
        

    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

/*{Modulo App Fim Favoritos}*/

/* module data info: Google Safe Browsing / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio Google Safe Browsing}*/

setTimeout(() => {
  
console.log("Google Safe Browsing OK");

try{
WsSecurityStamps("Google Safe Browsing", "https://transparencyreport.google.com/safe-browsing/search?url="+window.location.host, "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/google-safe-browsing.svg");
}catch(e){}

try{
let data = [
      {
        name: 'Google Safe Browsing',
        url: "https://transparencyreport.google.com/safe-browsing/search?url="+window.location.host,
        image: "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/google-safe-browsing.svg"
      }]
wsMain.modules['footer-badges'].create(data);
}catch(e){}


}, "1 second");

/*{Modulo App Fim Google Safe Browsing}*/

/* module data info: SSL LetsEncrypt / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio SSL LetsEncrypt}*/

setTimeout(() => {
  
console.log("Selo Lets Encrypt Inserido Vrs1.1");

try{
WsSecurityStamps("SSL Lets Encrypt", "", "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/LetsEncrypt.svg");
}catch(e){}

try{
let data = [
      {
        name: 'SSL Lets Encrypt',
        url: 'javascript:void()',
        image: "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/LetsEncrypt.svg?27092022"
      }]
wsMain.modules['footer-badges'].create(data);
}catch(e){}

}, 1000);

/*{Modulo App Fim SSL LetsEncrypt}*/

/* module data info: CookieConfirm / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio CookieConfirm}*/

(function () {
  "use strict";

  var STORAGE_KEY = "webstore_cookie_consent";
  var STYLE_ID = "webstore-cookie-consent-style";
  var BAR_ID = "webstore-cookie-consent-bar";

  function cookiesForamAceitos() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "accepted";
    } catch (error) {
      return false;
    }
  }

  function adicionarEstilos() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement("style");

    style.id = STYLE_ID;
    style.textContent = `
      #${BAR_ID} {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
        box-sizing: border-box;
        padding: 14px 30px;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
        color: #222;
        font-family: Arial, sans-serif;
        font-size: 12px;
        line-height: 1.4;
      }

      #${BAR_ID} .cookie-consent-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        width: 100%;
        max-width: 850px;
        margin: 0 auto;
      }

      #${BAR_ID} .cookie-consent-text {
        margin: 0;
      }

      #${BAR_ID} .cookie-consent-button {
        flex-shrink: 0;
        padding: 7px 18px;
        background-color: #FFF;
        border: 1px solid #222;
        border-radius: 3px;
        color: #222;
        font-family: inherit;
        font-size: 11px;
        line-height: 1;
        text-transform: uppercase;
        cursor: pointer;
        transition: opacity 0.2s ease;
      }

      #${BAR_ID} .cookie-consent-button:hover {
        opacity: 0.8;
      }

      @media (max-width: 600px) {
        #${BAR_ID} {
          padding: 12px 16px;
        }

        #${BAR_ID} .cookie-consent-content {
          gap: 12px;
        }

        #${BAR_ID} .cookie-consent-text {
          flex: 1;
          font-size: 11px;
        }

        #${BAR_ID} .cookie-consent-button {
          padding: 8px 12px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function criarBarraDeCookies() {
    if (
      cookiesForamAceitos() ||
      document.getElementById(BAR_ID)
    ) {
      return;
    }

    adicionarEstilos();

    var barra = document.createElement("div");
    var conteudo = document.createElement("div");
    var texto = document.createElement("p");
    var botao = document.createElement("button");

    barra.id = BAR_ID;
    conteudo.className = "cookie-consent-content";

    texto.className = "cookie-consent-text";
    texto.textContent =
      "Este site usa cookies para gerar estatísticas e melhorar sua experiência de navegação. Ao continuar, você declara que está de acordo.";

    botao.type = "button";
    botao.className = "cookie-consent-button";
    botao.textContent = "Aceitar";

    botao.addEventListener("click", function () {
      try {
        localStorage.setItem(STORAGE_KEY, "accepted");
      } catch (error) {
      }

      barra.remove();
    });

    conteudo.appendChild(texto);
    conteudo.appendChild(botao);
    barra.appendChild(conteudo);

    document.body.appendChild(barra);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      criarBarraDeCookies
    );
  } else {
    criarBarraDeCookies();
  }
})();

/*{Modulo App Fim CookieConfirm}*/

/* module data info: DataLayer / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio DataLayer}*/

console.log("modDatalayer started Vrs.28-09-2026");

window.addEventListener("load", () => {
    if (document.querySelector("#HdEtapaLoja").value == "HOME") { setTimeout(trigger_dataLayer, 5500); }
    else { setTimeout(trigger_dataLayer, 1000); }
});

function sendShippingEvent() {
  console.log('passou no shipment info')
  const input = document.querySelector("#ws-carrinhoNovo .frete .cepInput input");

  if(!input) return

  return ['add_shipping_info', {
    currency: 'BRL',
    value: cartJson.subtotal,
    shipping_tier: "Ground",
    items: cartJson.products.map(item => {
      return {
        item_id: item.sku,
        item_name: item.name,
        quantity: item.quantity,
        price: item.real_price
      }
    })
  }]
}

function sendPaymentEvent() {
  console.log('passou no payment info')
  const inputs = document.querySelectorAll(".LV_CheckoutSmart_Pagamento_Div .LV_CheckoutSmart_FormasPagamento_Div div .ListaFormasPgto li label");

  if(!inputs || !inputs.length) return;

  let selected = ''

  inputs.forEach(inp => {
    if(inp.classList.contains('Selected')) {
      if(inp.querySelector('.NomePagamento')) {
        selected = inp.querySelector('.NomePagamento').textContent;
      }
    }
  })

  if (!selected) return;

  return ['add_payment_info', {
    currency: 'BRL',
    value: orderData.total,
    payment_type: selected,
    items: orderData.products.map(item => {
      return {  
        item_id: item.sku,
        item_name: item.title,
        quantity: item.quantity,
        price: item.unit_price
      }
    })
  }]
}

function createEventTag(events) {
  if (!events) return;

  let scriptElem = document.createElement('script');

  events = Array.isArray(events[0]) ? events : [events];

  events.forEach(event => {
    let [eventName, eventData] = event;
    scriptElem.innerHTML += `gtag('event', '${eventName}', ${JSON.stringify(eventData, null, 2)});\n`;
  })

  let scriptConfig = document.createElement('script');
  scriptConfig.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());`


  if (typeof gtag === 'undefined') document.querySelector('head').append(scriptConfig)
  document.querySelector('head').append(scriptElem)
}

function trigger_dataLayer() {
  let actualStep = document.querySelector('#HdEtapaLoja').value;

  async function waitUntil(condition) {
    return await new Promise(resolve => {
      const interval = setInterval(() => {
        try {
          if (condition()) {
            resolve();
            clearInterval(interval);
          };
        } catch (err) { }
      }, 1000);
    });
  }

  function getProd(element) {
    return {
      ['item_id']: element.codigo,
      ['item_name']: element.nome,
      ['price']: parseFloat(element.precos?.preco_promocao ? element.precos?.preco_promocao : element.precos?.preco),
      ['item_brand']: element.fabricante?.nome
    }
  }

  function getAllProds() {
    let allProds = [];

    Object.keys(wsMain.globalData).forEach(columnName => {
      if ((columnName == 'listHomeProds' || columnName == 'listCategoryProds') && wsMain.globalData[columnName]) {
        wsMain.globalData[columnName].produtos.forEach(prod => allProds.push(getProd(prod)))
      }
      if (columnName == 'listGroupProds' && wsMain.globalData[columnName]) {
        wsMain.globalData[columnName].grupos.forEach(group => {
          group.produtos.forEach(prod => allProds.concat(getProd(prod)))
        })
      }
    });

    return allProds;
  }

  function getDeparment(objeto) {
    if (!objeto || !objeto.length) return null;

    for (const item of objeto) {
      if (item.atual) return item;

      if (item.hasOwnProperty("subcategorias")) {
        const categoriaEncontrada = getDeparment(item.subcategorias);
        if (categoriaEncontrada !== null) return categoriaEncontrada;
      }
    }

    return null;
  }

  function getEmailFromLocalStorage() {
    const email = localStorage.getItem("email");
    return email ? email : false;
  }

  const dataLayerFunctions = {
    'HOME': async () => {
      let dataFunction = () => wsMain.globalData?.listHomeProds || wsMain.globalData?.listGroupProds;

      await waitUntil(dataFunction);

      return ['view_item_list', {
        item_list_name: 'Produtos Home',
        items: getAllProds()
      }]
    },
    'LISTAGEM': async () => {
      let dataFunction = () => (wsMain.globalData?.listCategoryProds && wsMain.globalData?.infoCategory);
      await waitUntil(dataFunction);

      let returnArr = [

        ['view_item_list', {
          item_list_name: getDeparment(wsMain.globalData.infoCategory.Categorias)?.nome || 'Listagem de Produtos',
          item_list_id: getDeparment(wsMain.globalData.infoCategory.Categorias)?.id || 'search',
          items: getAllProds()
        }]

      ];

      if (window.location.pathname.indexOf('/busca/') != -1) {
        let searchArr = window.location.pathname.split('/');

        returnArr.push(['view_search_results', {
          search_term: searchArr[searchArr.length - 1]
        }])
      }

      return returnArr
    },
    'PRODUTO': async () => {
      let dataFunction = () => (wsMain.globalData?.infoProduto && wsMain.globalData?.infoCategory);
      await waitUntil(dataFunction);

      return ['view_item', {
        currency: 'BRL',
        value: getProd(wsMain.globalData.infoProduto).price,
        items: [getProd(wsMain.globalData.infoProduto)]
      }]
    },
    'FORMAS_PAGAMENTO': async () => {
      const arrToReturn = ['begin_checkout', {
        currency: 'BRL',
        value: orderData.total,
        items: orderData.products.map(item => {
          return {
            item_id: item.sku,
            item_name: item.title,
            quantity: item.quantity,
            price: item.unit_price
          }
        })
      }]

      getEmailFromLocalStorage() ? arrToReturn[1].email = getEmailFromLocalStorage() : null;

      return arrToReturn;
    },
    'FinalPagamento': async () => {
      return ['purchase', {
        currency: 'BRL',
        email: orderData.customer.email,
        name: orderData.customer.name,
        value: orderData.total,
        transaction_id: orderData.order_id,
        items: orderData.products.map(item => {
          return {
            item_id: item.sku,
            item_name: item.title,
            quantity: item.quantity,
            price: item.unit_price
          }
        })
      }]
    }
  }

  if (typeof callbackShippingSelected !== 'undefined' && Array.isArray(callbackShippingSelected)) {
    callbackShippingSelected.push("createEventTag(sendShippingEvent())");
  }

  if (typeof callbackPaymentSelected !== 'undefined' && Array.isArray(callbackPaymentSelected)) {
    callbackPaymentSelected.push("createEventTag(sendPaymentEvent())");
  }

  async function print_dataLayer() {
    try {
      let scriptElem = document.createElement('script');

      let events = await dataLayerFunctions[actualStep]();

      events = Array.isArray(events[0]) ? events : [events];

      events.forEach(event => {
        let [eventName, eventData] = event;
        scriptElem.innerHTML += `gtag('event', '${eventName}', ${JSON.stringify(eventData, null, 2)});\n`;
      })

      let scriptConfig = document.createElement('script');
      scriptConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());`


      if (typeof gtag === 'undefined') document.querySelector('head').append(scriptConfig)
      document.querySelector('head').append(scriptElem)
    } catch (err) {
      console.log('Erro inesperado do DataLayer \n', err);
    }
  }

  if (Object.keys(dataLayerFunctions).includes(actualStep)) print_dataLayer();
}


/*{Modulo App Fim DataLayer}*/

/* module data info: Webstore Assinatura / all app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio Webstore Assinatura}*/

setTimeout(() => {
    if (typeof notWsSign === "undefined") {
        const wsClass = Math.floor(Math.random() * 1000);
        const nomeLoja = $("#HD_LV_NOME").val() || "";
        const wsUrl =
            "https://www.webstore.com.br/?utm_source=" +
            encodeURIComponent(nomeLoja) +
            "&utm_medium=referral&utm_campaign=customers&utm_content=webstore";

        const imgSrcAttribute =
            typeof wsMain !== "undefined" ? "data-wsjs-src" : "src";

        $("body").append(`
            <div id="ws_sign_${wsClass}" class="ws${wsClass}">
                <div id="ws${wsClass}">
                    <div>
                        <span>Tecnologia</span>
                        <a href="${wsUrl}"
                           target="_blank"
                           rel="noopener"
                           title="Webstore | Plataforma de E-commerce para criar ou montar loja virtual">
                            <img ${imgSrcAttribute}="/logo/logo-webstore.svg"
                                 data-wsjs-lazyload="scroll"
                                 class="lazyload"
                                 alt="Webstore plataforma de e-commerce"
                                 width="111"
                                 height="16" />
                        </a>
                    </div>
                </div>
            </div>
        `);

        $("body").append(`
            <style rel="wstokencss83130_93483081">
                body .ws${wsClass} {
                    background-color: #FFF !important;
                    padding: 20px;
                }

                body .ws${wsClass} #ws${wsClass} {
                    display: table !important;
                    margin: 0 auto !important;
                    font-size: 11px !important;
                    font-family: Arial !important;
                    color: #666;
                    clear: both !important;
                }

                body .ws${wsClass} div span {
                    display: inline-block !important;
                    padding: 0px 6px !important;
                    float: left !important;
                }

                body .ws${wsClass} div a {
                    display: inline-block !important;
                    opacity: 1;
                    -webkit-filter: grayscale(100%);
                    filter: grayscale(100%);
                    transition: -webkit-filter 0.5s, filter 0.5s, opacity 0.5s;
                    padding-top: 4px;
                }

                body .ws${wsClass} div a img {
                    width: 111px;
                }

                body .ws${wsClass} div a:hover {
                    opacity: 1 !important;
                    -webkit-filter: grayscale(0%) !important;
                    filter: grayscale(0%) !important;
                }
            </style>
        `);
    }
}, 2000);

/*{Modulo App Fim Webstore Assinatura}*/

/* module data info: Whatsapp / in app added at (2026-10-07 06:09:54) */

/*{Modulo App Inicio Whatsapp}*/

function StartWhatsWs() {

    try {

        var data1 = '51980193857';
	var data2 = 'ID';

	console.log("Whatsapp iniciado "+ data1);

        var LinkUse = "https://web.whatsapp.com/send?phone=55";
        var w = window.innerWidth;

        if (w < 900) {
            LinkUse = "https://wa.me/55";
        }

        $("body").append("<a href='" + LinkUse + data1 + "' id='btwhatstalk' title='Fale conosco pelo Whatsapp' target='_blank' class='whats-ws-link whatslink"+data2+"'>" +
                         "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path d='M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z'/></svg>" +
                         "</a>");

	window.setTimeout("actionWhatsWs()", 1000);


    } catch (e) {
        console.log("Falha app Whatsapp:" + e.message);
    }

}

function actionWhatsWs(){
	$("#btwhatstalk").click(function(){

		let scriptConfig = document.createElement('script');
    
		scriptConfig.innerHTML = `try{gtag('event', 'chat_initiated');}catch(e){}`;

		document.querySelector('body').append(scriptConfig)

	});
}

window.setTimeout("StartWhatsWs()", 1000);

/*{Modulo App Fim Whatsapp}*/

/* module data info: All Modulos Add 2026-10-07 06:09:54 */